
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4hoOb", function(module, exports) {
/**
 * @generated SignedSource<<12eaa439262a1782573c59e73c1b7ac1>>
 * @relayHash 2b75fc1121e53c1c0a5ad6a53dc0d745
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da67c9639926a2efc46d2b199b1e767f62d394339ad04fad1158a6e32d14ceab
const $50da084713014cf6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "coverPictureWidth"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "coverPictureWidth",
                            "variableName": "coverPictureWidth"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "UpdateCoverPictureWidthPayload",
            "kind": "LinkedField",
            "name": "updateCoverPictureWidth",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2b75fc1121e53c1c0a5ad6a53dc0d745",
            "id": "da67c9639926a2efc46d2b199b1e767f62d394339ad04fad1158a6e32d14ceab",
            "metadata": {},
            "name": "EditorPageCoverPictureUpdateCoverPictureWidthMutation",
            "operationKind": "mutation",
            "text": "mutation EditorPageCoverPictureUpdateCoverPictureWidthMutation($contentId:ID!,$coverPictureWidth:GraphQLCoverPictureWidth!){updateCoverPictureWidth(input:{contentId:$contentId,coverPictureWidth:$coverPictureWidth}){content{id}}}"
        }
    };
}();
$50da084713014cf6$var$node.hash = "d3df2b12316133bd2b6a3afaae602a82";
var $50da084713014cf6$export$2e2bcd8739ae039 = $50da084713014cf6$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4ez2K = parcelRequire("4ez2K");


var $9DHhW = parcelRequire("9DHhW");


var $cTZvm = parcelRequire("cTZvm");


var $5ZJRm = parcelRequire("5ZJRm");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1P7Cq = parcelRequire("1P7Cq");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2vVvv = parcelRequire("2vVvv");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $7aRa9 = parcelRequire("7aRa9");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $g6QPm = parcelRequire("g6QPm");


var $7PLO8 = parcelRequire("7PLO8");


var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5kqgA = parcelRequire("5kqgA");


var $dA1Sn = parcelRequire("dA1Sn");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $3gyyc = parcelRequire("3gyyc");


var $3WPGR = parcelRequire("3WPGR");


var $bKd7w = parcelRequire("bKd7w");


var $75Ax4 = parcelRequire("75Ax4");


var $lC6Qd = parcelRequire("lC6Qd");


var $bCpIa = parcelRequire("bCpIa");


var $bDgLe = parcelRequire("bDgLe");





var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $iQxQk = parcelRequire("iQxQk");
























const $2dd1934ae4bb18c2$var$COVER_IMAGE_FIXED_HEIGHT = 147;
const $2dd1934ae4bb18c2$var$COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO = 38 / 7;
const $2dd1934ae4bb18c2$var$CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE = `round(down, calc(100cqw / (${$2dd1934ae4bb18c2$var$COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO})), 1px)`;
const $2dd1934ae4bb18c2$export$e9a5ef24ed345990 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "img" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, isRoundedCorners: isRoundedCorners, coverPicturePosition: coverPicturePosition, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px"),
                "--_7bw3ey": (0, $9aYkv.default)(`center ${__cmplp.coverPicturePosition}%`)
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_39xV02N91d _00EA0eiObl _1mT5xdWVPG _1PLshBhlUx _3v5uP0K4e3 _2OgLIs7dHp",
                __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : "_0jFU0VbQHl",
                __cmplp.isRoundedCorners ? "_0bjKvDyzSk" : "_0bjKvDZqHV",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});


/* ImageWrapperCss.tsx generated by @compiled/babel-plugin v3.0.2 */ 





const $5368c62a8152c252$var$COVER_IMAGE_FIXED_HEIGHT = 147;
const $5368c62a8152c252$var$SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH = 200;
const $5368c62a8152c252$var$COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO = 38 / 7;
const $5368c62a8152c252$var$CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE = `round(down, calc(100cqw / (${$5368c62a8152c252$var$COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO})), 1px)`;
const $5368c62a8152c252$var$imageWrapperStyles = {
    base: "_39xV02N91d _00EA0eiObl _1mT5xdWVPG _3v5uP0K4e3 _2OgLIs7dHp",
    fixed: "_0jFU0V6Tex",
    fixedHeight: "_0jFU0VgZxp",
    scaled: "_0jFU0VbQHl",
    roundedCorners: "_0bjKvDyzSk"
};
const $5368c62a8152c252$export$b3be81165a87bf6f = ({ coverPicturePosition: coverPicturePosition, isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isRoundedCorners: isRoundedCorners, style: style, ...imgProps })=>{
    'use no memo'; // Exclude from React compiler - breaks unit tests when component uses compiled CSS
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        ...imgProps,
        alt: "",
        style: {
            objectPosition: `center ${coverPicturePosition}%`,
            ...style
        },
        className: (0, $hekY6.default)([
            $5368c62a8152c252$var$imageWrapperStyles.base,
            $5368c62a8152c252$var$imageWrapperStyles[smartSpaceOverviewHeight ? 'fixedHeight' : isFixedWidthImageOption ? 'fixed' : 'scaled'],
            isRoundedCorners && $5368c62a8152c252$var$imageWrapperStyles.roundedCorners
        ])
    });
};


const $66db09fad5336912$export$75f07c36086c2c81 = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    let coverPicturePosition;
    let imgProps;
    let isFixedWidthImageOption;
    let isRoundedCorners;
    let smartSpaceOverviewHeight;
    if ($[0] !== t0) {
        ({ coverPicturePosition: coverPicturePosition, isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isRoundedCorners: isRoundedCorners, ...imgProps } = t0);
        $[0] = t0;
        $[1] = coverPicturePosition;
        $[2] = imgProps;
        $[3] = isFixedWidthImageOption;
        $[4] = isRoundedCorners;
        $[5] = smartSpaceOverviewHeight;
    } else {
        coverPicturePosition = $[1];
        imgProps = $[2];
        isFixedWidthImageOption = $[3];
        isRoundedCorners = $[4];
        smartSpaceOverviewHeight = $[5];
    }
    if ((0, $6mKj3.expValEquals)("confluence_page_cover_picture_css_migration", "isEnabled", true)) {
        let t1;
        if ($[6] !== coverPicturePosition || $[7] !== imgProps || $[8] !== isFixedWidthImageOption || $[9] !== isRoundedCorners || $[10] !== smartSpaceOverviewHeight) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5368c62a8152c252$export$b3be81165a87bf6f), {
                ...imgProps,
                coverPicturePosition: coverPicturePosition,
                isFixedWidthImageOption: isFixedWidthImageOption,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                isRoundedCorners: isRoundedCorners
            });
            $[6] = coverPicturePosition;
            $[7] = imgProps;
            $[8] = isFixedWidthImageOption;
            $[9] = isRoundedCorners;
            $[10] = smartSpaceOverviewHeight;
            $[11] = t1;
        } else t1 = $[11];
        return t1;
    }
    let t1;
    if ($[12] !== coverPicturePosition || $[13] !== imgProps || $[14] !== isFixedWidthImageOption || $[15] !== isRoundedCorners || $[16] !== smartSpaceOverviewHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2dd1934ae4bb18c2$export$e9a5ef24ed345990), {
            ...imgProps,
            alt: "",
            coverPicturePosition: coverPicturePosition,
            isFixedWidthImageOption: isFixedWidthImageOption,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            isRoundedCorners: isRoundedCorners
        });
        $[12] = coverPicturePosition;
        $[13] = imgProps;
        $[14] = isFixedWidthImageOption;
        $[15] = isRoundedCorners;
        $[16] = smartSpaceOverviewHeight;
        $[17] = t1;
    } else t1 = $[17];
    return t1;
};


const $6daaa50e0e3ea99a$var$styles = {
    loading: "_1mT5xdRAKS _0jFU0VN91d _0KLXrumhAQ"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6daaa50e0e3ea99a$var$LoadingDivWithCss = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.smartSpaceOverviewHeight ?? __cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = `-${__cmplp.smartSpaceOverviewHeight ?? __cmplp.dynamicCoverImageHeight}px`;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_13y1ha6": t4,
                "--_1jwbla4": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2uo31fmhAQ _0bjKvDZqHV _1mT5xdRAKS _0jFU0VN91d _4kiQYAyPTS _1DCdHixcJy",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $6daaa50e0e3ea99a$var$LoadingDiv = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { dynamicCoverImageHeight: dynamicCoverImageHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight } = t0;
    if ((0, $6mKj3.expValEquals)("confluence_page_cover_picture_css_migration", "isEnabled", true)) {
        const t1 = smartSpaceOverviewHeight ? `${smartSpaceOverviewHeight}px` : dynamicCoverImageHeight ? `${dynamicCoverImageHeight}px` : undefined;
        const t2 = smartSpaceOverviewHeight ? `-${smartSpaceOverviewHeight}px` : dynamicCoverImageHeight ? `-${dynamicCoverImageHeight}px` : undefined;
        let t3;
        if ($[0] !== t1 || $[1] !== t2) {
            t3 = {
                minHeight: t1,
                marginBottom: t2
            };
            $[0] = t1;
            $[1] = t2;
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = (0, $hekY6.default)([
                $6daaa50e0e3ea99a$var$styles.loading
            ]);
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== t3) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                style: t3,
                "data-testid": "cover-pic-loading-css",
                className: t4
            });
            $[4] = t3;
            $[5] = t5;
        } else t5 = $[5];
        return t5;
    }
    let t1;
    if ($[6] !== dynamicCoverImageHeight || $[7] !== smartSpaceOverviewHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6daaa50e0e3ea99a$var$LoadingDivWithCss, {
            "data-testid": "cover-pic-loading",
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight
        });
        $[6] = dynamicCoverImageHeight;
        $[7] = smartSpaceOverviewHeight;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
};
const $6daaa50e0e3ea99a$export$22e679d20747684f = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { coverPicture: coverPicture, dynamicCoverImageHeight: dynamicCoverImageHeight, showErrorFlag: showErrorFlag, mediaConfig: mediaConfig, ssrConfig: ssrConfig, contentId: contentId, coverPictureId: coverPictureId, coverPicturePosition: coverPicturePosition, hasSSRConfigInSSRModeOrHydration: hasSSRConfigInSSRModeOrHydration, useEditorMediaConfig: useEditorMediaConfig, isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isAIGenerated: isAIGenerated, isRoundedCorners: isRoundedCorners } = t0;
    const useSSRConfig = hasSSRConfigInSSRModeOrHydration && !isAIGenerated && !useEditorMediaConfig;
    let t1;
    if ($[0] !== mediaConfig || $[1] !== ssrConfig || $[2] !== useSSRConfig) {
        t1 = useSSRConfig ? ssrConfig && ssrConfig.config : mediaConfig && {
            authProvider: mediaConfig.authProvider
        };
        $[0] = mediaConfig;
        $[1] = ssrConfig;
        $[2] = useSSRConfig;
        $[3] = t1;
    } else t1 = $[3];
    const mediaClientConfig = t1;
    const collectionName = useSSRConfig || useEditorMediaConfig ? `contentId-${contentId}` : mediaConfig?.collection;
    const coverPictureDraftId = coverPictureId || coverPicture.current.draft?.value.id;
    const resolvedCoverPicturePosition = coverPicturePosition ?? coverPicture.current.draft?.value.position;
    if (!coverPictureDraftId) return null;
    if (mediaClientConfig) {
        let t2;
        if ($[4] !== collectionName || $[5] !== coverPictureDraftId) {
            t2 = {
                mediaItemType: "file",
                id: coverPictureDraftId,
                collectionName: collectionName
            };
            $[4] = collectionName;
            $[5] = coverPictureDraftId;
            $[6] = t2;
        } else t2 = $[6];
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                allowAnimated: true,
                mode: "full-fit",
                upscale: false
            };
            $[7] = t3;
        } else t3 = $[7];
        const t4 = useSSRConfig ? ssrConfig?.mode : undefined;
        let t5;
        if ($[8] !== dynamicCoverImageHeight || $[9] !== isAIGenerated || $[10] !== isFixedWidthImageOption || $[11] !== isRoundedCorners || $[12] !== resolvedCoverPicturePosition || $[13] !== showErrorFlag || $[14] !== smartSpaceOverviewHeight) {
            t5 = (t6)=>{
                const { data: data, loading: loading, error: error } = t6;
                if (loading) {
                    if (isAIGenerated && ((0, $6mKj3.isExperimentEnabled)("cc_page_experiences_ai_header_image_generation") || (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_aifc_auto_generated_header_img"))) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6daaa50e0e3ea99a$var$LoadingDiv, {
                        dynamicCoverImageHeight: dynamicCoverImageHeight,
                        smartSpaceOverviewHeight: smartSpaceOverviewHeight
                    });
                }
                if (!data) return null;
                if (error) showErrorFlag();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66db09fad5336912$export$75f07c36086c2c81), {
                    "data-testid": "actual-cover-picture",
                    id: "actual-cover-picture",
                    src: data.src,
                    coverPicturePosition: resolvedCoverPicturePosition,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                    isRoundedCorners: isRoundedCorners,
                    className: "cover-picture-wrapper-dangerously-set-inner-html"
                });
            };
            $[8] = dynamicCoverImageHeight;
            $[9] = isAIGenerated;
            $[10] = isFixedWidthImageOption;
            $[11] = isRoundedCorners;
            $[12] = resolvedCoverPicturePosition;
            $[13] = showErrorFlag;
            $[14] = smartSpaceOverviewHeight;
            $[15] = t5;
        } else t5 = $[15];
        let t6;
        if ($[16] !== coverPictureDraftId || $[17] !== mediaClientConfig || $[18] !== t2 || $[19] !== t4 || $[20] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iQxQk.MediaImageWithErrorBoundary), {
                identifier: t2,
                mediaClientConfig: mediaClientConfig,
                key: coverPictureDraftId,
                apiConfig: t3,
                ssr: t4
            }, t5);
            $[16] = coverPictureDraftId;
            $[17] = mediaClientConfig;
            $[18] = t2;
            $[19] = t4;
            $[20] = t5;
            $[21] = t6;
        } else t6 = $[21];
        return t6;
    }
};














var $lfoFx = parcelRequire("lfoFx");














var $iaYF8 = parcelRequire("iaYF8");











var $7ZB0A = parcelRequire("7ZB0A");


var $6NvYG = parcelRequire("6NvYG");


var $4n1IT = parcelRequire("4n1IT");














var $3ricL = parcelRequire("3ricL");








var $lpNn5 = parcelRequire("lpNn5");


var $iDfTs = parcelRequire("iDfTs");


var $dLFT2 = parcelRequire("dLFT2");


var $dVbiN = parcelRequire("dVbiN");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $eLJUB = parcelRequire("eLJUB");


var $e70Gu = parcelRequire("e70Gu");


var $gH7sg = parcelRequire("gH7sg");


var $9XB2W = parcelRequire("9XB2W");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");

















var $7sJoX = parcelRequire("7sJoX");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $jp2Q3 = parcelRequire("jp2Q3");








var $jVylI = parcelRequire("jVylI");

const $98591a14e75c6a83$var$i18n = (0, $kSwu1.defineMessages)({
    fixedWidthSelectOption: {
        id: "content-topper.page-title.popup.fixed-width.option",
        defaultMessage: "Fixed width"
    },
    fullWidthSelectOption: {
        id: "content-topper.page-title.popup.full-width.option",
        defaultMessage: "Full width"
    },
    selectWidthLabel: {
        id: "content-topper.page-title.popup.select-width.label",
        defaultMessage: "Select width: {selectedWidth}"
    }
});
const $98591a14e75c6a83$export$6164b97a36f48473 = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { userOffline: userOffline, onImageWidthChange: onImageWidthChange, selectedWidth: t1, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected } = t0;
    const selectedWidth = t1 === undefined ? (0, $jVylI.COVERPICTUREWIDTH).FULL : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent) {
        t2 = (coverPictureWidth)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    source: "widthToggleDropdownButton",
                    actionSubject: "button",
                    actionSubjectId: `${coverPictureWidth}WidthToggleDropdownButton`
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t2;
    } else t2 = $[1];
    const createWidthToggleDropdownAnalytics = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $jp2Q3.layers).dialog();
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== intl || $[4] !== selectedWidth || $[5] !== userOffline) {
        t4 = (t5)=>{
            const { triggerRef: triggerRef, ...props } = t5;
            const selectedLabel = selectedWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL ? intl.formatMessage($98591a14e75c6a83$var$i18n.fullWidthSelectOption) : intl.formatMessage($98591a14e75c6a83$var$i18n.fixedWidthSelectOption);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "",
                    size: "small"
                }),
                ref: triggerRef,
                shouldFitContainer: true,
                style: {
                    textAlign: "left"
                },
                isDisabled: userOffline,
                "aria-label": intl.formatMessage($98591a14e75c6a83$var$i18n.selectWidthLabel, {
                    selectedWidth: selectedLabel
                })
            }, selectedWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98591a14e75c6a83$var$i18n.fullWidthSelectOption) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98591a14e75c6a83$var$i18n.fixedWidthSelectOption));
        };
        $[3] = intl;
        $[4] = selectedWidth;
        $[5] = userOffline;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== createWidthToggleDropdownAnalytics || $[8] !== onCoverImageWidthDropdownOptionSelected || $[9] !== onImageWidthChange || $[10] !== selectedWidth) {
        t5 = ()=>{
            onImageWidthChange((0, $jVylI.COVERPICTUREWIDTH).FULL);
            createWidthToggleDropdownAnalytics((0, $jVylI.COVERPICTUREWIDTH).FULL);
            onCoverImageWidthDropdownOptionSelected?.(selectedWidth !== (0, $jVylI.COVERPICTUREWIDTH).FULL);
        };
        $[7] = createWidthToggleDropdownAnalytics;
        $[8] = onCoverImageWidthDropdownOptionSelected;
        $[9] = onImageWidthChange;
        $[10] = selectedWidth;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98591a14e75c6a83$var$i18n.fullWidthSelectOption);
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            onClick: t5,
            testId: "coverPictureFullWidthToggleDropdownItem"
        }, t6);
        $[13] = t5;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== createWidthToggleDropdownAnalytics || $[16] !== onCoverImageWidthDropdownOptionSelected || $[17] !== onImageWidthChange || $[18] !== selectedWidth) {
        t8 = ()=>{
            onImageWidthChange((0, $jVylI.COVERPICTUREWIDTH).FIXED);
            createWidthToggleDropdownAnalytics((0, $jVylI.COVERPICTUREWIDTH).FIXED);
            onCoverImageWidthDropdownOptionSelected?.(selectedWidth !== (0, $jVylI.COVERPICTUREWIDTH).FIXED);
        };
        $[15] = createWidthToggleDropdownAnalytics;
        $[16] = onCoverImageWidthDropdownOptionSelected;
        $[17] = onImageWidthChange;
        $[18] = selectedWidth;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $98591a14e75c6a83$var$i18n.fixedWidthSelectOption);
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: (0, $jVylI.COVERPICTUREWIDTH).FIXED,
            onClick: t8,
            testId: "coverPictureFixedWidthToggleDropdownItem"
        }, t9);
        $[21] = t8;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10 || $[24] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t7, t10);
        $[23] = t10;
        $[24] = t7;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t11 || $[27] !== t4) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-start",
            zIndex: t3,
            shouldRenderToParent: true,
            shouldFitContainer: true,
            trigger: t4
        }, t11);
        $[26] = t11;
        $[27] = t4;
        $[28] = t12;
    } else t12 = $[28];
    return t12;
};



var $f7B1p = parcelRequire("f7B1p");







const $d69b5edb6613d5ce$export$d3c50eeab3c808b = async (downloadLink)=>{
    return (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/download`, {
        method: 'POST',
        body: JSON.stringify({
            downloadLink: downloadLink
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
        });
        throw error;
    });
};


const $15d7949f30979aaa$export$8d7ce798f348099f = ()=>[
        'Based on this page information, output a single sentence (max 20 words) describing an image suitable as a cover image.',
        'The image must visually represent the main topic of the page using relevant symbols, objects, or metaphors.',
        'Do not include human elements unless distant and unrecognizable.',
        'Include a specific visual style and color tone.',
        'Output only the sentence. No preamble. No quotes. No markdown.'
    ].join(' ');
const $15d7949f30979aaa$export$91104a6680d86a2c = (raw)=>{
    const trimmed = (raw ?? '').trim();
    const unquoted = trimmed.startsWith('"') && trimmed.endsWith('"') || trimmed.startsWith("'") && trimmed.endsWith("'") ? trimmed.slice(1, -1).trim() : trimmed;
    const firstLine = unquoted.split(/\r?\n/)[0]?.trim() ?? '';
    const withoutPrefix = firstLine.replace(/^(prompt|output)\s*:\s*/i, '').trim();
    const words = withoutPrefix.split(/\s+/).filter(Boolean);
    return words.length <= 25 ? withoutPrefix : words.slice(0, 25).join(' ');
};
const $15d7949f30979aaa$export$bf7a2998b22ba28c = ()=>{
    // Mirror the EditorTitle pattern: pick the first non-chromeless editor.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const proseMirrors = Array.from(document.querySelectorAll('.ProseMirror')).filter((el)=>!el.closest('[data-testid="chromeless-editor"]') && !el.closest('[data-editor-popup]'));
    return proseMirrors[0]?.dataset?.editorId;
};


const $e611c24abe969f89$var$i18n = (0, $kSwu1.defineMessages)({
    popupTitleLabel: {
        id: "content-topper.page-title.popup.label",
        defaultMessage: "Header image"
    },
    popupTitleLabelSubtext: {
        id: "content-topper.page-title.popup.label.subtext",
        defaultMessage: "We recommend images 1100px or wider."
    },
    repositionButton: {
        id: "content-topper.page-title.popup.reposition",
        defaultMessage: "Reposition"
    },
    removeHeaderButton: {
        id: "content-topper.page-title.popup.remove-image",
        defaultMessage: "Remove image"
    },
    suggestPromptLabel: {
        id: "content-topper.page-title.popup.suggest-image-prompt",
        defaultMessage: "Suggest"
    },
    suggestPromptTooltip: {
        id: "content-topper.page-title.popup.suggest-image-prompt.tooltip",
        defaultMessage: "Suggest from page content"
    }
});
const $e611c24abe969f89$var$PopupWrapperStyles = (0, $buxP3.xcss)({
    padding: 'space.200',
    width: '280px',
    userSelect: 'none'
});
const $e611c24abe969f89$var$headerImageGeneratorWrapperStyles = {
    root: "_313842TUhv"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$DeleteButtonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3tQyB5dnbC _1Jqxx1T9KB _4qcoZB2ADO _1ET69JT9KB",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$PositionIconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3138424Jdh _0adFHsdnbC _1DCdHidnbC _2XsHFM7vQP _1VJPcaf5G3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e611c24abe969f89$var$MenuOptionsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fwxA5ecOK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e611c24abe969f89$export$5e27412e512156d4 = (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { imageSrc: imageSrc, imageAltText: imageAltText, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, coverPictureState: coverPictureState, closePopup: closePopup, setIsUploadingPicture: setIsUploadingPicture, handleUnsplashUpload: handleUnsplashUpload, onReposition: onReposition, onDelete: onDelete, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, userOffline: userOffline, contentId: contentId, isPageTitleComponent: isPageTitleComponent, onImageWidthChange: onImageWidthChange, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected, generateAIHeaderImage: generateAIHeaderImage } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const [t1] = (0, $ep3mz.usePageState)();
    const { spaceKey: spaceKey } = t1;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isSuggestingPrompt, setIsSuggestingPrompt] = (0, $cozmU.useState)(false);
    const [suggestedPrompt, setSuggestedPrompt] = (0, $cozmU.useState)("");
    const mountedRef = (0, $cozmU.useRef)(true);
    let t2;
    if ($[0] !== generateAIHeaderImage) {
        t2 = (props)=>generateAIHeaderImage({
                ...props,
                aspectRatio: "4:1",
                theme: props.theme ?? (0, $gH7sg.IMAGE_GENERATION_THEMES).headerImages
            });
        $[0] = generateAIHeaderImage;
        $[1] = t2;
    } else t2 = $[1];
    const generateWideAIHeaderImage = t2;
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            mountedRef.current = true;
            return ()=>{
                mountedRef.current = false;
            };
        };
        t4 = [];
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[4] !== createAnalyticsEvent) {
        t5 = (t6)=>{
            const { isButtonDisabled: isButtonDisabled, isEditorIdMissing: isEditorIdMissing } = t6;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    source: "unsplashPopupMenu",
                    actionSubject: "button",
                    actionSubjectId: "headerImagePromptSuggestion",
                    attributes: {
                        isButtonDisabled: isButtonDisabled,
                        isEditorIdMissing: isEditorIdMissing
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = t5;
    } else t5 = $[5];
    const fireSuggestHeaderImageButtonAnalytics = t5;
    let t6;
    if ($[6] !== createAnalyticsEvent) {
        t6 = (t7)=>{
            const { promptGenerationSuccessful: promptGenerationSuccessful, resultType: resultType, isRegeneratingPrompt: isRegeneratingPrompt } = t7;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    actionSubject: "headerImagePromptSuggestionGeneration",
                    action: promptGenerationSuccessful && resultType === "complete" ? "completed" : "failed",
                    source: "headerImagePromptSuggestionButton",
                    attributes: {
                        promptGenerationSuccessful: promptGenerationSuccessful,
                        resultType: resultType,
                        isRegeneratingPrompt: isRegeneratingPrompt
                    }
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = t6;
    } else t6 = $[7];
    const fireSuggestHeaderImagePromptResultAnalytics = t6;
    let t7;
    if ($[8] !== fireSuggestHeaderImageButtonAnalytics || $[9] !== fireSuggestHeaderImagePromptResultAnalytics || $[10] !== isSuggestingPrompt || $[11] !== suggestedPrompt || $[12] !== userOffline) {
        t7 = ()=>{
            const isButtonDisabled_0 = userOffline || isSuggestingPrompt;
            const targetEditorId = (0, $15d7949f30979aaa$export$bf7a2998b22ba28c)();
            fireSuggestHeaderImageButtonAnalytics({
                isButtonDisabled: isButtonDisabled_0,
                isEditorIdMissing: !targetEditorId
            });
            if (isButtonDisabled_0 || !targetEditorId) return;
            const isRegenerating = Boolean(suggestedPrompt?.trim());
            setIsSuggestingPrompt(true);
            setSuggestedPrompt("");
            (0, $9XB2W.eventHub).publishToEditor({
                event: "start prompt",
                data: {
                    targetEditorId: targetEditorId,
                    analyticSourceId: "confluenceCoverImagePromptSuggestionPopup",
                    prompt: "custom prompt",
                    promptText: (0, $15d7949f30979aaa$export$8d7ce798f348099f)(),
                    adjustSelection: "fullDocument",
                    hideModal: true,
                    streamingCallback: (data)=>{
                        if (data.type === "complete") {
                            const suggestion = (0, $15d7949f30979aaa$export$91104a6680d86a2c)(data.result ?? "");
                            if (mountedRef.current) {
                                setIsSuggestingPrompt(false);
                                setSuggestedPrompt(suggestion);
                                fireSuggestHeaderImagePromptResultAnalytics({
                                    promptGenerationSuccessful: true,
                                    resultType: data.type,
                                    isRegeneratingPrompt: isRegenerating
                                });
                            } else fireSuggestHeaderImagePromptResultAnalytics({
                                promptGenerationSuccessful: false,
                                resultType: "not mounted",
                                isRegeneratingPrompt: isRegenerating
                            });
                        } else if (data.type === "error" || data.type === "response too similar") {
                            if (mountedRef.current) setIsSuggestingPrompt(false);
                            fireSuggestHeaderImagePromptResultAnalytics({
                                promptGenerationSuccessful: false,
                                resultType: data.type,
                                isRegeneratingPrompt: isRegenerating
                            });
                        }
                    }
                }
            });
        };
        $[8] = fireSuggestHeaderImageButtonAnalytics;
        $[9] = fireSuggestHeaderImagePromptResultAnalytics;
        $[10] = isSuggestingPrompt;
        $[11] = suggestedPrompt;
        $[12] = userOffline;
        $[13] = t7;
    } else t7 = $[13];
    const handleSuggestImagePromptClick = t7;
    let t8;
    if ($[14] !== closePopup || $[15] !== coverPictureState || $[16] !== experienceTracker || $[17] !== handleUnsplashUpload || $[18] !== setIsUploadingPicture) {
        t8 = async (url, downloadLink)=>{
            experienceTracker.start({
                name: (0, $irVI7.COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE)
            });
            await (0, $d69b5edb6613d5ce$export$d3c50eeab3c808b)(downloadLink);
            handleUnsplashUpload(url);
            setIsUploadingPicture(true);
            coverPictureState.setIsUploadingPicture(true);
            closePopup();
        };
        $[14] = closePopup;
        $[15] = coverPictureState;
        $[16] = experienceTracker;
        $[17] = handleUnsplashUpload;
        $[18] = setIsUploadingPicture;
        $[19] = t8;
    } else t8 = $[19];
    const onUnsplashImageClick = t8;
    let t9;
    if ($[20] !== coverPictureState || $[21] !== onUnsplashImageClick) {
        t9 = async (t10)=>{
            const { fullSizeImageUrl: fullSizeImageUrl, downloadLink: downloadLink_0 } = t10;
            await onUnsplashImageClick(fullSizeImageUrl, downloadLink_0);
            coverPictureState.setIsChangingPicture(false);
        };
        $[20] = coverPictureState;
        $[21] = onUnsplashImageClick;
        $[22] = t9;
    } else t9 = $[22];
    const handleImageSelection = t9;
    const t10 = dropdownRef;
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e611c24abe969f89$var$i18n.popupTitleLabelSubtext);
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e611c24abe969f89$var$i18n.popupTitleLabel);
        $[24] = t12;
    } else t12 = $[24];
    const t13 = dropdownPopupComponentRef;
    let t14;
    if ($[25] !== contentId || $[26] !== handleImageSelection || $[27] !== imageAltText || $[28] !== imageSrc || $[29] !== initialUnsplashInfoArray || $[30] !== isPageTitleComponent || $[31] !== openMediaBrowser || $[32] !== t13 || $[33] !== userOffline) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eLJUB.UnsplashSearch), {
            selectedImageUrl: imageSrc,
            imageAltText: imageAltText,
            initialUnsplashResults: initialUnsplashInfoArray,
            idPrefix: "unsplash-popup",
            helperMessage: t11,
            handleImageSelection: handleImageSelection,
            openMediaBrowser: openMediaBrowser,
            sectionLabel: t12,
            dropdownPopupComponentRef: t13,
            isDisabled: userOffline,
            contentId: contentId,
            isPageTitleComponent: isPageTitleComponent,
            isNoImageAllowed: false,
            analyticsSource: "editorPageCoverPicture",
            analyticsActionSubject: "headerImageUpload",
            analyticsActionSubjectId: "headerImageUploadButtonClicked",
            enableBottomSpacing: false
        });
        $[25] = contentId;
        $[26] = handleImageSelection;
        $[27] = imageAltText;
        $[28] = imageSrc;
        $[29] = initialUnsplashInfoArray;
        $[30] = isPageTitleComponent;
        $[31] = openMediaBrowser;
        $[32] = t13;
        $[33] = userOffline;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] !== coverPictureState.state || $[36] !== onCoverImageWidthDropdownOptionSelected || $[37] !== onImageWidthChange || $[38] !== spaceKey || $[39] !== userOffline) {
        t15 = !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && typeof onImageWidthChange === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98591a14e75c6a83$export$6164b97a36f48473), {
            onImageWidthChange: onImageWidthChange,
            userOffline: userOffline,
            selectedWidth: coverPictureState.state.coverPictureWidth,
            onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected
        }) : null;
        $[35] = coverPictureState.state;
        $[36] = onCoverImageWidthDropdownOptionSelected;
        $[37] = onImageWidthChange;
        $[38] = spaceKey;
        $[39] = userOffline;
        $[40] = t15;
    } else t15 = $[40];
    let t16;
    if ($[41] !== onReposition || $[42] !== userOffline) {
        t16 = typeof onReposition === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e611c24abe969f89$var$PositionIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dLFT2))), {
                label: "",
                spacing: "none"
            })),
            testId: "reposition-image-button",
            isDisabled: userOffline,
            onClick: onReposition,
            shouldFitContainer: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e611c24abe969f89$var$MenuOptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e611c24abe969f89$var$i18n.repositionButton))) : null;
        $[41] = onReposition;
        $[42] = userOffline;
        $[43] = t16;
    } else t16 = $[43];
    let t17;
    if ($[44] !== createAnalyticsEvent || $[45] !== generateAIHeaderImage || $[46] !== generateWideAIHeaderImage || $[47] !== handleSuggestImagePromptClick || $[48] !== intl || $[49] !== isSuggestingPrompt || $[50] !== suggestedPrompt || $[51] !== userOffline) {
        t17 = (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_ai_header_image_generation") && (0, $3ricL.isFeatureEnabled)("confluence", "confluence-ai") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $e611c24abe969f89$var$headerImageGeneratorWrapperStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e70Gu.RovoHeaderImageGenerator), {
            allowImageModelSelection: !(0, $9wGTI.fg)("header_images_migrate_image_gen_to_remix"),
            generateAIHeaderImage: generateAIHeaderImage && (0, $9wGTI.fg)("header_images_migrate_image_gen_to_remix") ? generateWideAIHeaderImage : generateAIHeaderImage,
            isDisabled: Boolean(userOffline),
            prefillText: suggestedPrompt || undefined,
            useRemixStyleOptions: (0, $9wGTI.fg)("header_images_migrate_image_gen_to_remix"),
            onSubmit: (t18)=>{
                const { imageGenerationModel: imageGenerationModel, selectedTheme: selectedTheme } = t18;
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "headerImageGenerationSubmitted",
                        source: "editorPageCoverPicture",
                        attributes: {
                            imageGenerationModel: imageGenerationModel,
                            selectedTheme: selectedTheme
                        }
                    }
                }).fire();
            },
            moreActionsButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: intl.formatMessage($e611c24abe969f89$var$i18n.suggestPromptTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                type: "button",
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))), {
                    label: ""
                }),
                isDisabled: Boolean(userOffline) || isSuggestingPrompt,
                onClick: handleSuggestImagePromptClick,
                testId: "suggest-ai-image-prompt-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e611c24abe969f89$var$i18n.suggestPromptLabel)))
        }));
        $[44] = createAnalyticsEvent;
        $[45] = generateAIHeaderImage;
        $[46] = generateWideAIHeaderImage;
        $[47] = handleSuggestImagePromptClick;
        $[48] = intl;
        $[49] = isSuggestingPrompt;
        $[50] = suggestedPrompt;
        $[51] = userOffline;
        $[52] = t17;
    } else t17 = $[52];
    let t18;
    if ($[53] !== onDelete || $[54] !== userOffline) {
        t18 = typeof onDelete === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e611c24abe969f89$var$DeleteButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                label: ""
            }),
            shouldFitContainer: true,
            onClick: onDelete,
            isDisabled: userOffline,
            testId: "remove-image-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e611c24abe969f89$var$MenuOptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e611c24abe969f89$var$i18n.removeHeaderButton)))) : null;
        $[53] = onDelete;
        $[54] = userOffline;
        $[55] = t18;
    } else t18 = $[55];
    let t19;
    if ($[56] !== t10 || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t17 || $[61] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            ref: t10,
            xcss: $e611c24abe969f89$var$PopupWrapperStyles,
            space: "space.100"
        }, t14, t15, t16, t17, t18);
        $[56] = t10;
        $[57] = t14;
        $[58] = t15;
        $[59] = t16;
        $[60] = t17;
        $[61] = t18;
        $[62] = t19;
    } else t19 = $[62];
    return t19;
};


const $a391e9da6cc7b48e$var$i18n = (0, $kSwu1.defineMessages)({
    headerLabel: {
        id: "content-topper.add.header.image.message.floating-toolbar",
        defaultMessage: "Header image"
    },
    updateImage: {
        id: "content-topper.page-title.popup.update.header.image",
        defaultMessage: "Update header image"
    }
});
const $a391e9da6cc7b48e$export$44d946b74397afda = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { isModalOpenState: isModalOpenState, closePopup: closePopup, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, userOffline: userOffline, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, onAddHeaderImageButtonClicked: onAddHeaderImageButtonClicked, onAddHeaderImageButtonHovered: onAddHeaderImageButtonHovered, onReposition: onReposition, onDelete: onDelete, imageSrc: imageSrc, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, contentId: contentId, generateAIHeaderImage: generateAIHeaderImage } = t0;
    let t1;
    if ($[0] !== closePopup || $[1] !== contentId || $[2] !== coverPictureState || $[3] !== dropdownPopupComponentRef || $[4] !== dropdownRef || $[5] !== generateAIHeaderImage || $[6] !== handleUnsplashUpload || $[7] !== imageSrc || $[8] !== initialUnsplashInfoArray || $[9] !== onDelete || $[10] !== onReposition || $[11] !== openMediaBrowser || $[12] !== setIsUploadingPicture || $[13] !== userOffline) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e611c24abe969f89$export$5e27412e512156d4), {
                dropdownRef: dropdownRef,
                imageSrc: imageSrc,
                initialUnsplashInfoArray: initialUnsplashInfoArray,
                openMediaBrowser: openMediaBrowser,
                handleUnsplashUpload: handleUnsplashUpload,
                setIsUploadingPicture: setIsUploadingPicture,
                coverPictureState: coverPictureState,
                closePopup: closePopup,
                onReposition: onReposition,
                onDelete: onDelete,
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                contentId: contentId,
                isPageTitleComponent: true,
                userOffline: userOffline,
                generateAIHeaderImage: generateAIHeaderImage
            });
        $[0] = closePopup;
        $[1] = contentId;
        $[2] = coverPictureState;
        $[3] = dropdownPopupComponentRef;
        $[4] = dropdownRef;
        $[5] = generateAIHeaderImage;
        $[6] = handleUnsplashUpload;
        $[7] = imageSrc;
        $[8] = initialUnsplashInfoArray;
        $[9] = onDelete;
        $[10] = onReposition;
        $[11] = openMediaBrowser;
        $[12] = setIsUploadingPicture;
        $[13] = userOffline;
        $[14] = t1;
    } else t1 = $[14];
    let t2;
    if ($[15] !== floatingToolbarButtonStyle || $[16] !== isModalOpenState || $[17] !== onAddHeaderImageButtonClicked || $[18] !== onAddHeaderImageButtonHovered || $[19] !== userOffline) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...triggerProps,
                isSelected: isModalOpenState,
                appearance: "subtle",
                style: floatingToolbarButtonStyle || {},
                testId: "add-header-image-button",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6NvYG))), {
                    label: ""
                }),
                onClick: onAddHeaderImageButtonClicked,
                isDisabled: userOffline,
                onMouseEnter: onAddHeaderImageButtonHovered
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: "add-header-image-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a391e9da6cc7b48e$var$i18n.headerLabel)));
        $[15] = floatingToolbarButtonStyle;
        $[16] = isModalOpenState;
        $[17] = onAddHeaderImageButtonClicked;
        $[18] = onAddHeaderImageButtonHovered;
        $[19] = userOffline;
        $[20] = t2;
    } else t2 = $[20];
    let t3;
    if ($[21] !== closePopup || $[22] !== isModalOpenState || $[23] !== t1 || $[24] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isModalOpenState,
            onClose: closePopup,
            placement: "bottom-start",
            role: "dialog",
            shouldRenderToParent: false,
            content: t1,
            trigger: t2
        });
        $[21] = closePopup;
        $[22] = isModalOpenState;
        $[23] = t1;
        $[24] = t2;
        $[25] = t3;
    } else t3 = $[25];
    return t3;
};








async function $3297a981dc10fa5b$export$c23d8af8b1b8f2d7(queryWord, pageNumber, isPageTitleComponent) {
    return (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/search?query=${queryWord}&pageNumber=${pageNumber}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then((responseData)=>{
        const unsplashResults = responseData.results ?? [];
        return unsplashResults.map((result)=>({
                artistName: result.user.name,
                artistUrl: result.user.links.html + (0, $75Ax4.REFERRAL_LINK),
                fullSizeImageUrl: isPageTitleComponent ? result.urls.full : result.urls.regular,
                smallSizeImageUrl: result.urls.thumb,
                description: result.description,
                downloadLink: result.links.download_location
            }));
    });
}
function $3297a981dc10fa5b$export$d3c50eeab3c808b(downloadLink) {
    (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/unsplash/download`, {
        method: 'POST',
        body: JSON.stringify({
            downloadLink: downloadLink
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
}


const $b276f472a35f7217$var$styles = {
    addHeaderImageButton: "_1YKVNs7dHp"
};
const $b276f472a35f7217$export$97958e565d90ce0a = (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { userOffline: userOffline, openModal: openModal, openMediaBrowser: openMediaBrowser, isModalOpenState: isModalOpenState, closeModal: closeModal, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, initialUnsplashInfoArray: initialUnsplashInfoArray, setInitialUnsplashInfoArray: setInitialUnsplashInfoArray, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, contentId: contentId, generateAIHeaderImage: generateAIHeaderImage, analyticsSource: t1 } = t0;
    const analyticsSource = t1 === undefined ? "editorPageCoverPicture" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isPageTitleComponent = true;
    let t2;
    if ($[0] !== initialUnsplashInfoArray.length || $[1] !== setInitialUnsplashInfoArray) {
        t2 = ()=>{
            if (initialUnsplashInfoArray.length === 0) (0, $3297a981dc10fa5b$export$c23d8af8b1b8f2d7)((0, $iaYF8.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD), 1, true).then((results)=>{
                setInitialUnsplashInfoArray(results);
            });
        };
        $[0] = initialUnsplashInfoArray.length;
        $[1] = setInitialUnsplashInfoArray;
        $[2] = t2;
    } else t2 = $[2];
    const onAddHeaderImageButtonHovered = t2;
    let t3;
    if ($[3] !== analyticsSource || $[4] !== createAnalyticsEvent || $[5] !== openModal) {
        t3 = ()=>{
            openModal();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "addHeaderImageButtonClicked",
                    source: analyticsSource
                }
            }).fire();
        };
        $[3] = analyticsSource;
        $[4] = createAnalyticsEvent;
        $[5] = openModal;
        $[6] = t3;
    } else t3 = $[6];
    const onAddHeaderImageButtonClicked = t3;
    let t4;
    if ($[7] !== coverPictureState || $[8] !== isModalOpenState) {
        t4 = ()=>{
            if (!isModalOpenState) coverPictureState.setIsAddHeaderImageButtonFocused(true);
        };
        $[7] = coverPictureState;
        $[8] = isModalOpenState;
        $[9] = t4;
    } else t4 = $[9];
    const handleFocus = t4;
    let t5;
    if ($[10] !== coverPictureState) {
        t5 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(false);
        };
        $[10] = coverPictureState;
        $[11] = t5;
    } else t5 = $[11];
    const handleBlur = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $b276f472a35f7217$var$styles.addHeaderImageButton
        ]);
        $[12] = t6;
    } else t6 = $[12];
    const t7 = initialUnsplashInfoArray;
    let t8;
    if ($[13] !== closeModal || $[14] !== contentId || $[15] !== coverPictureState || $[16] !== floatingToolbarButtonStyle || $[17] !== generateAIHeaderImage || $[18] !== handleUnsplashUpload || $[19] !== isModalOpenState || $[20] !== onAddHeaderImageButtonClicked || $[21] !== onAddHeaderImageButtonHovered || $[22] !== openMediaBrowser || $[23] !== setIsUploadingPicture || $[24] !== t7 || $[25] !== userOffline) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a391e9da6cc7b48e$export$44d946b74397afda), {
            imageSrc: "",
            initialUnsplashInfoArray: t7,
            openMediaBrowser: openMediaBrowser,
            handleUnsplashUpload: handleUnsplashUpload,
            setIsUploadingPicture: setIsUploadingPicture,
            coverPictureState: coverPictureState,
            closePopup: closeModal,
            userOffline: userOffline,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            isModalOpenState: isModalOpenState,
            onAddHeaderImageButtonClicked: onAddHeaderImageButtonClicked,
            onAddHeaderImageButtonHovered: onAddHeaderImageButtonHovered,
            contentId: contentId,
            generateAIHeaderImage: generateAIHeaderImage
        });
        $[13] = closeModal;
        $[14] = contentId;
        $[15] = coverPictureState;
        $[16] = floatingToolbarButtonStyle;
        $[17] = generateAIHeaderImage;
        $[18] = handleUnsplashUpload;
        $[19] = isModalOpenState;
        $[20] = onAddHeaderImageButtonClicked;
        $[21] = onAddHeaderImageButtonHovered;
        $[22] = openMediaBrowser;
        $[23] = setIsUploadingPicture;
        $[24] = t7;
        $[25] = userOffline;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== handleBlur || $[28] !== handleFocus || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "add-header-image-button-wrapper",
            onFocus: handleFocus,
            onBlur: handleBlur,
            className: t6
        }, t8);
        $[27] = handleBlur;
        $[28] = handleFocus;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    return t9;
};




























const $46b253a18b421305$var$i18n = (0, $kSwu1.defineMessages)({
    dragToReposition: {
        id: "page-cover-picture.drag.to.reposition.message",
        defaultMessage: "Drag to reposition"
    },
    saveReposition: {
        id: "page-cover-picture.save.reposition",
        defaultMessage: "Apply"
    },
    cancelReposition: {
        id: "page-cover-picture.cancel.reposition",
        defaultMessage: "Cancel"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46b253a18b421305$var$RepositionWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { userOffline: userOffline, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2uo31fDMqu _3iDTPbQ4SZ _0hPCNLDIqT _0fKRyPYvD1 _0jFU0VuNcX _39xV02N91d",
            __cmplp.userOffline ? "_0wOv4Qsyl5" : "_0wOv4Q18ZR",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $46b253a18b421305$var$DragToRepositionTextWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg20Hp _1UtDYz7Cj1 _3iDTPbQ4SZ _39xV02cVZy _37wbyuz9WS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $46b253a18b421305$var$RepositionButtonText = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $46b253a18b421305$var$RepositionButtonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02wOVE _3iDTPbQ4SZ _37wbyuz9WS _0adFHs2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $46b253a18b421305$var$RepositionImageWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1mT5xdRAKS _0jFU0Vc2HY _39xV02N91d _3iDTPbQ4SZ _0hPCNLchRC",
                __cmplp.userOffline ? "_0wOv4Qsyl5" : "_0wOv4QaHnk",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $46b253a18b421305$export$78e1d98d4f84631f = ({ initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, setIsRepositionActive: setIsRepositionActive, setShouldShowReposition: setShouldShowReposition, coverPictureState: coverPictureState, forceUpdate: forceUpdate, userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, analyticsSource: analyticsSource = 'editorPageCoverPicture' })=>{
    const userOfflineRef = (0, $cozmU.useRef)(userOffline);
    (0, $cozmU.useEffect)(()=>{
        userOfflineRef.current = userOffline;
    }, [
        userOffline
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleRepositionImageMouseDown = ()=>{
        // if we are here that means reposition is active since the div is visible to the user and user just moused down inside the image
        // they want to reposition
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.addEventListener('mousemove', handleMouseMove);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseUp = ()=>{
        removeListeners();
    };
    let oldClientY = 0;
    const curPos = (0, $cozmU.useRef)(initialPicturePosition || (0, $75Ax4.DEFAULT_POSITION_VALUE));
    const handleMouseMove = (e)=>{
        if (userOfflineRef.current) {
            removeListeners();
            return;
        }
        e.preventDefault();
        // prevent text selection
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const img = document.getElementById('actual-cover-picture');
        if (!img) return;
        if (e.clientY > oldClientY) // mouse moved down
        {
            if (curPos.current - 0.75 >= 0) {
                curPos.current -= 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        } else if (e.clientY < oldClientY) // mouse moved up
        {
            if (curPos.current + 0.75 <= 100) {
                curPos.current += 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        }
        oldClientY = e.clientY;
    };
    const removeListeners = ()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.removeEventListener('mousemove', handleMouseMove);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.removeEventListener('mouseup', handleMouseUp);
    };
    const saveReposition = async ()=>{
        coverPictureState.setIsRepositioningPicture(true);
        await onSaveReposition(curPos.current);
        setIsRepositionActive(false);
        setShouldShowReposition(false);
        coverPictureState.setIsRepositioningPicture(false);
        removeListeners();
        await coverPictureState.setIsChangingPicture(false);
        await coverPictureState.setShouldShowReposition(false);
        forceUpdate?.(Math.random());
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'repositionSaveButtonClicked',
                source: analyticsSource,
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    };
    const cancelReposition = async ()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const img_0 = document.getElementById('actual-cover-picture');
        setIsRepositionActive(false);
        setShouldShowReposition(false);
        coverPictureState.setIsRepositioningPicture(false);
        removeListeners();
        await coverPictureState.setShouldShowReposition(false);
        await coverPictureState.setIsChangingPicture(false);
        forceUpdate?.(Math.random());
        if (img_0) img_0.style.objectPosition = `center ${initialPicturePosition}%`;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'repositionCancelButtonClicked',
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46b253a18b421305$var$RepositionImageWrapper, {
        onMouseDown: userOffline ? undefined : handleRepositionImageMouseDown,
        "data-testid": "reposition-div",
        userOffline: userOffline,
        dynamicCoverImageHeight: dynamicCoverImageHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46b253a18b421305$var$RepositionWrapper, {
        userOffline: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46b253a18b421305$var$DragToRepositionTextWrapper, null, formatMessage($46b253a18b421305$var$i18n.dragToReposition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46b253a18b421305$var$RepositionButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "save-reposition-button",
        spacing: "compact",
        onClick: saveReposition,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginRight: "var(--ds-space-200, 16px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginLeft: "var(--ds-space-negative-100, -8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-025, 2px)"
        },
        isDisabled: userOffline,
        autoFocus: !userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46b253a18b421305$var$RepositionButtonText, null, formatMessage($46b253a18b421305$var$i18n.saveReposition))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "cancel-reposition-button",
        spacing: "compact",
        onClick: cancelReposition,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-025, 2px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginLeft: "var(--ds-space-negative-050, -4px)"
        },
        isDisabled: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46b253a18b421305$var$RepositionButtonText, null, formatMessage($46b253a18b421305$var$i18n.cancelReposition))))));
};


















































const $1bbfbc20e55661d7$var$i18n = (0, $kSwu1.defineMessages)({
    headerLabel: {
        id: "content-topper.add.header.image.message.floating-toolbar",
        defaultMessage: "Header image"
    },
    updateImage: {
        id: "content-topper.page-title.popup.update.header.image",
        defaultMessage: "Update header image"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1bbfbc20e55661d7$var$DropdownTrigger = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        const { userOffline: userOffline, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0aFT5vbt8w _3TGfC9LRg7 _2uo31fYbGa _30huDKYbGa _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYz7Cj1 _2xIroY9SWg",
            __cmplp.userOffline ? "_0wOv4Qsyl5" : "_0wOv4Q7zJH",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1bbfbc20e55661d7$export$f190f045ee817cbf = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { isModalOpenState: isModalOpenState, closePopup: closePopup, initialUnsplashInfoArray: initialUnsplashInfoArray, openMediaBrowser: openMediaBrowser, userOffline: userOffline, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, onReposition: onReposition, onDelete: onDelete, imageSrc: imageSrc, dropdownRef: dropdownRef, dropdownPopupComponentRef: dropdownPopupComponentRef, contentId: contentId, onImageWidthChange: onImageWidthChange, onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected, generateAIHeaderImage: generateAIHeaderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $jp2Q3.layers).dialog();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== floatingToolbarButtonStyle || $[2] !== isModalOpenState || $[3] !== userOffline) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1bbfbc20e55661d7$var$DropdownTrigger, {
                "data-testid": "update-image-button",
                ...triggerProps,
                tabIndex: 0,
                "aria-expanded": isModalOpenState,
                ref: triggerProps.ref,
                style: floatingToolbarButtonStyle || {},
                userOffline: userOffline,
                disabled: userOffline
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6NvYG))), {
                label: "",
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1bbfbc20e55661d7$var$i18n.updateImage));
        $[1] = floatingToolbarButtonStyle;
        $[2] = isModalOpenState;
        $[3] = userOffline;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== closePopup || $[6] !== contentId || $[7] !== coverPictureState || $[8] !== dropdownPopupComponentRef || $[9] !== dropdownRef || $[10] !== generateAIHeaderImage || $[11] !== handleUnsplashUpload || $[12] !== imageSrc || $[13] !== initialUnsplashInfoArray || $[14] !== onCoverImageWidthDropdownOptionSelected || $[15] !== onDelete || $[16] !== onImageWidthChange || $[17] !== onReposition || $[18] !== openMediaBrowser || $[19] !== setIsUploadingPicture || $[20] !== userOffline) {
        t3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e611c24abe969f89$export$5e27412e512156d4), {
                dropdownRef: dropdownRef,
                contentId: contentId,
                imageSrc: imageSrc,
                initialUnsplashInfoArray: initialUnsplashInfoArray,
                openMediaBrowser: openMediaBrowser,
                handleUnsplashUpload: handleUnsplashUpload,
                setIsUploadingPicture: setIsUploadingPicture,
                coverPictureState: coverPictureState,
                closePopup: closePopup,
                onReposition: onReposition,
                onDelete: onDelete,
                placement: "bottom",
                userOffline: userOffline,
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                onImageWidthChange: onImageWidthChange,
                isPageTitleComponent: true,
                onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected,
                generateAIHeaderImage: generateAIHeaderImage
            });
        $[5] = closePopup;
        $[6] = contentId;
        $[7] = coverPictureState;
        $[8] = dropdownPopupComponentRef;
        $[9] = dropdownRef;
        $[10] = generateAIHeaderImage;
        $[11] = handleUnsplashUpload;
        $[12] = imageSrc;
        $[13] = initialUnsplashInfoArray;
        $[14] = onCoverImageWidthDropdownOptionSelected;
        $[15] = onDelete;
        $[16] = onImageWidthChange;
        $[17] = onReposition;
        $[18] = openMediaBrowser;
        $[19] = setIsUploadingPicture;
        $[20] = userOffline;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== closePopup || $[23] !== isModalOpenState || $[24] !== t2 || $[25] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isModalOpenState,
            onClose: closePopup,
            placement: "bottom",
            zIndex: t1,
            strategy: "absolute",
            shouldRenderToParent: true,
            role: "dialog",
            trigger: t2,
            content: t3
        });
        $[22] = closePopup;
        $[23] = isModalOpenState;
        $[24] = t2;
        $[25] = t3;
        $[26] = t4;
    } else t4 = $[26];
    return t4;
};



const $d56946553982f95c$var$COVER_IMAGE_FIXED_HEIGHT = 147; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d56946553982f95c$var$HoverOverlay = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, userOffline: userOffline, isRoundedCorners: isRoundedCorners, isDropdownOpen: isDropdownOpen, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2uo31fKcZT _39xV02N91d _1mT5xdRAKS _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
                __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : "_0jFU0VbQHl",
                __cmplp.userOffline ? "_0wOv4Qsyl5" : "_0wOv4Q7zJH",
                __cmplp.isRoundedCorners ? "_0bjKvDyzSk" : "_0bjKvDKxmn",
                __cmplp.isDropdownOpen ? "_1YKVNs7dHp" : "_1YKVNsdnbC",
                __cmplp.userOffline ? "_2OgLIsdnbC" : "_2OgLIs7dHp",
                __cmplp.userOffline ? "_3Tg68SdnbC" : "_3Tg68S7dHp",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $d56946553982f95c$export$d83b52f1c3c4071e = (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { userOffline: userOffline, closeModal: closeModal, openMediaBrowser: openMediaBrowser, setIsRepositionActive: setIsRepositionActive, onRemoveImage: onRemoveImage, onImageWidthChange: onImageWidthChange, handleUnsplashUpload: handleUnsplashUpload, setIsUploadingPicture: setIsUploadingPicture, initialUnsplashInfoArray: initialUnsplashInfoArray, setInitialUnsplashInfoArray: setInitialUnsplashInfoArray, coverPictureState: coverPictureState, contentId: contentId, dynamicCoverImageHeight: dynamicCoverImageHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, generateAIHeaderImage: generateAIHeaderImage, isRoundedCorners: isRoundedCorners, analyticsSource: t1 } = t0;
    const analyticsSource = t1 === undefined ? "editorPageCoverPicture" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const overlayComponent = (0, $cozmU.useRef)(null);
    const dropdownComponent = (0, $cozmU.useRef)(null);
    const dropdownPopupComponentRef = (0, $cozmU.useRef)(null);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t2;
    if ($[0] !== coverPictureState) {
        t2 = (event)=>{
            if (overlayComponent?.current && event.target instanceof Node && !overlayComponent?.current?.contains(event.target) && !dropdownComponent?.current?.contains(event.target) && !dropdownPopupComponentRef?.current?.contains(event.target) && coverPictureState.state.isChangingPicture) {
                coverPictureState.setIsChangingPicture(false);
                setIsDropdownOpen(false);
            }
        };
        $[0] = coverPictureState;
        $[1] = t2;
    } else t2 = $[1];
    const handleClickOutside = t2;
    let t3;
    let t4;
    if ($[2] !== handleClickOutside) {
        t3 = ()=>{
            addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        };
        t4 = [
            handleClickOutside
        ];
        $[2] = handleClickOutside;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[5] !== analyticsSource || $[6] !== coverPictureState || $[7] !== createAnalyticsEvent || $[8] !== initialUnsplashInfoArray || $[9] !== isLivePage || $[10] !== setInitialUnsplashInfoArray) {
        t5 = (event_0)=>{
            if (event_0.target instanceof Node && (dropdownComponent?.current?.contains(event_0.target) || dropdownPopupComponentRef?.current?.contains(event_0.target))) return;
            if (initialUnsplashInfoArray.length === 0) (0, $3297a981dc10fa5b$export$c23d8af8b1b8f2d7)((0, $iaYF8.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD), 1, true).then((results)=>{
                setInitialUnsplashInfoArray(results);
            });
            const isChangingPicture = coverPictureState.state.isChangingPicture;
            coverPictureState.setIsChangingPicture(!isChangingPicture);
            setIsDropdownOpen($d56946553982f95c$var$_temp);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "update",
                    actionSubjectId: "updateHeaderImageButtonClicked",
                    source: analyticsSource,
                    attributes: {
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[5] = analyticsSource;
        $[6] = coverPictureState;
        $[7] = createAnalyticsEvent;
        $[8] = initialUnsplashInfoArray;
        $[9] = isLivePage;
        $[10] = setInitialUnsplashInfoArray;
        $[11] = t5;
    } else t5 = $[11];
    const toggleDropdownOpen = t5;
    let t6;
    if ($[12] !== analyticsSource || $[13] !== coverPictureState || $[14] !== createAnalyticsEvent || $[15] !== setIsRepositionActive) {
        t6 = ()=>{
            setIsRepositionActive(true);
            coverPictureState.setIsChangingPicture(false);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "reposition",
                    actionSubjectId: "repositionHeaderImageButtonClicked",
                    source: analyticsSource
                }
            }).fire();
        };
        $[12] = analyticsSource;
        $[13] = coverPictureState;
        $[14] = createAnalyticsEvent;
        $[15] = setIsRepositionActive;
        $[16] = t6;
    } else t6 = $[16];
    const onRepositionClicked = t6;
    let t7;
    if ($[17] !== analyticsSource || $[18] !== coverPictureState.state.isCurrentAIFCAutoImage || $[19] !== createAnalyticsEvent || $[20] !== experienceTracker || $[21] !== isLivePage || $[22] !== onRemoveImage) {
        t7 = ()=>{
            const removedAIFCAutoGeneratedImage = coverPictureState.state.isCurrentAIFCAutoImage;
            experienceTracker.start({
                name: (0, $irVI7.COVER_PICTURE_REMOVE_EXPERIENCE)
            });
            onRemoveImage();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "remove",
                    actionSubjectId: "removeHeaderImageButtonClicked",
                    source: analyticsSource,
                    attributes: {
                        isLivePage: isLivePage,
                        removedAIFCAutoGeneratedImage: removedAIFCAutoGeneratedImage
                    }
                }
            }).fire();
        };
        $[17] = analyticsSource;
        $[18] = coverPictureState.state.isCurrentAIFCAutoImage;
        $[19] = createAnalyticsEvent;
        $[20] = experienceTracker;
        $[21] = isLivePage;
        $[22] = onRemoveImage;
        $[23] = t7;
    } else t7 = $[23];
    const onRemoveImageClicked = t7;
    let t8;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (isCoverImageWidthChanged)=>{
            if (isCoverImageWidthChanged) setIsDropdownOpen(false);
        };
        $[24] = t8;
    } else t8 = $[24];
    const onCoverImageWidthDropdownOptionSelected = t8;
    let t9;
    if ($[25] !== coverPictureState) {
        t9 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(true);
        };
        $[25] = coverPictureState;
        $[26] = t9;
    } else t9 = $[26];
    const handleFocus = t9;
    let t10;
    if ($[27] !== coverPictureState) {
        t10 = ()=>{
            coverPictureState.setIsAddHeaderImageButtonFocused(false);
        };
        $[27] = coverPictureState;
        $[28] = t10;
    } else t10 = $[28];
    const handleBlur = t10;
    const t11 = userOffline ? undefined : toggleDropdownOpen;
    let t12;
    if ($[29] !== closeModal || $[30] !== contentId || $[31] !== coverPictureState || $[32] !== generateAIHeaderImage || $[33] !== handleUnsplashUpload || $[34] !== initialUnsplashInfoArray || $[35] !== isDropdownOpen || $[36] !== onImageWidthChange || $[37] !== onRemoveImageClicked || $[38] !== onRepositionClicked || $[39] !== openMediaBrowser || $[40] !== setIsUploadingPicture || $[41] !== userOffline) {
        t12 = !userOffline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1bbfbc20e55661d7$export$f190f045ee817cbf), {
            dropdownRef: dropdownComponent,
            onDelete: onRemoveImageClicked,
            onReposition: onRepositionClicked,
            imageSrc: coverPictureState.state.coverPictureId,
            isModalOpenState: isDropdownOpen,
            openMediaBrowser: openMediaBrowser,
            initialUnsplashInfoArray: initialUnsplashInfoArray,
            closePopup: closeModal,
            userOffline: userOffline,
            handleUnsplashUpload: handleUnsplashUpload,
            setIsUploadingPicture: setIsUploadingPicture,
            coverPictureState: coverPictureState,
            dropdownPopupComponentRef: dropdownPopupComponentRef,
            contentId: contentId,
            onImageWidthChange: onImageWidthChange,
            onCoverImageWidthDropdownOptionSelected: onCoverImageWidthDropdownOptionSelected,
            generateAIHeaderImage: generateAIHeaderImage
        });
        $[29] = closeModal;
        $[30] = contentId;
        $[31] = coverPictureState;
        $[32] = generateAIHeaderImage;
        $[33] = handleUnsplashUpload;
        $[34] = initialUnsplashInfoArray;
        $[35] = isDropdownOpen;
        $[36] = onImageWidthChange;
        $[37] = onRemoveImageClicked;
        $[38] = onRepositionClicked;
        $[39] = openMediaBrowser;
        $[40] = setIsUploadingPicture;
        $[41] = userOffline;
        $[42] = t12;
    } else t12 = $[42];
    let t13;
    if ($[43] !== dynamicCoverImageHeight || $[44] !== isDropdownOpen || $[45] !== isFixedWidthImageOption || $[46] !== isRoundedCorners || $[47] !== smartSpaceOverviewHeight || $[48] !== t11 || $[49] !== t12 || $[50] !== userOffline) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d56946553982f95c$var$HoverOverlay, {
            "data-testid": "hover-overlay-custom-sites",
            isDropdownOpen: isDropdownOpen,
            onClick: t11,
            ref: overlayComponent,
            userOffline: userOffline,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isRoundedCorners: isRoundedCorners,
            className: "cover-picture-wrapper-dangerously-set-inner-html"
        }, t12);
        $[43] = dynamicCoverImageHeight;
        $[44] = isDropdownOpen;
        $[45] = isFixedWidthImageOption;
        $[46] = isRoundedCorners;
        $[47] = smartSpaceOverviewHeight;
        $[48] = t11;
        $[49] = t12;
        $[50] = userOffline;
        $[51] = t13;
    } else t13 = $[51];
    let t14;
    if ($[52] !== handleBlur || $[53] !== handleFocus || $[54] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onFocus: handleFocus,
            onBlur: handleBlur
        }, t13);
        $[52] = handleBlur;
        $[53] = handleFocus;
        $[54] = t13;
        $[55] = t14;
    } else t14 = $[55];
    return t14;
};
function $d56946553982f95c$var$_temp(prevIsDropdownOpen) {
    return !prevIsDropdownOpen;
}































const $07a01d3f99018a4a$var$i18n = (0, $kSwu1.defineMessages)({
    dragToReposition: {
        id: "page-cover-picture.ai-acceptance.drag.to.reposition.message",
        defaultMessage: "Drag to reposition"
    },
    accept: {
        id: "page-cover-picture.ai-acceptance.accept",
        defaultMessage: "Accept"
    },
    discard: {
        id: "page-cover-picture.ai-acceptance.discard",
        defaultMessage: "Discard"
    },
    retry: {
        id: "page-cover-picture.ai-acceptance.retry",
        defaultMessage: "Retry"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $07a01d3f99018a4a$var$RepositionWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { userOffline: userOffline, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2uo31fDMqu _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0fKRyPYvD1 _0jFU0VUF4f _39xV02N91d _2Zuz6Q5zaO _1Znuxb5zaO",
            __cmplp.userOffline ? "_0wOv4Qsyl5" : "_0wOv4Q18ZR",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$DragToRepositionTextWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg20Hp _1UtDYz7Cj1 _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$ButtonText = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$AcceptButtonText = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYze5R3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$ButtonGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $07a01d3f99018a4a$var$RepositionImageWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1mT5xdRAKS _0jFU0Vc2HY _39xV02N91d _3iDTPbQ4SZ _0hPCNLchRC",
                __cmplp.userOffline ? "_0wOv4Qsyl5" : "_0wOv4QaHnk",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $07a01d3f99018a4a$export$33aaeca88e7c46bf = ({ initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, onAccept: onAccept, onDiscard: onDiscard, onRetry: onRetry, isRetrying: isRetrying, coverPictureState: coverPictureState, forceUpdate: forceUpdate, userOffline: userOffline, dynamicCoverImageHeight: dynamicCoverImageHeight, analyticsSource: analyticsSource = 'editorPageCoverPicture' })=>{
    const userOfflineRef = (0, $cozmU.useRef)(userOffline);
    (0, $cozmU.useEffect)(()=>{
        userOfflineRef.current = userOffline;
    }, [
        userOffline
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const handleRepositionImageMouseDown = ()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.addEventListener('mousemove', handleMouseMove);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseUp = ()=>{
        removeListeners();
    };
    let oldClientY = 0;
    const curPos = (0, $cozmU.useRef)(initialPicturePosition || (0, $75Ax4.DEFAULT_POSITION_VALUE));
    const handleMouseMove = (e)=>{
        if (userOfflineRef.current) {
            removeListeners();
            return;
        }
        e.preventDefault();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const img = document.getElementById('actual-cover-picture');
        if (!img) return;
        if (e.clientY > oldClientY) {
            if (curPos.current - 0.75 >= 0) {
                curPos.current -= 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        } else if (e.clientY < oldClientY) {
            if (curPos.current + 0.75 <= 100) {
                curPos.current += 0.75;
                img.style.objectPosition = `center ${curPos.current}%`;
            }
        }
        oldClientY = e.clientY;
    };
    const removeListeners = ()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.removeEventListener('mousemove', handleMouseMove);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.removeEventListener('mouseup', handleMouseUp);
    };
    const handleAccept = async ()=>{
        coverPictureState.setIsRepositioningPicture(true);
        await onSaveReposition(curPos.current);
        coverPictureState.setIsRepositioningPicture(false);
        removeListeners();
        onAccept();
        await coverPictureState.setIsChangingPicture(false);
        forceUpdate?.(Date.now());
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiImageAcceptanceAcceptButtonClicked',
                source: analyticsSource,
                attributes: {
                    isLivePage: isLivePage,
                    position: curPos.current
                }
            }
        }).fire();
    };
    const handleDiscard = async ()=>{
        removeListeners();
        await coverPictureState.setIsChangingPicture(false);
        forceUpdate?.(Date.now());
        onDiscard();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiImageAcceptanceDiscardButtonClicked',
                source: analyticsSource,
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    };
    const handleRetry = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiImageAcceptanceRetryButtonClicked',
                source: analyticsSource,
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
        onRetry();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07a01d3f99018a4a$var$RepositionImageWrapper, {
        onMouseDown: userOffline ? undefined : handleRepositionImageMouseDown,
        "data-testid": "ai-image-acceptance-repositioner",
        userOffline: userOffline,
        dynamicCoverImageHeight: dynamicCoverImageHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07a01d3f99018a4a$var$RepositionWrapper, {
        userOffline: userOffline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07a01d3f99018a4a$var$DragToRepositionTextWrapper, null, formatMessage($07a01d3f99018a4a$var$i18n.dragToReposition)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07a01d3f99018a4a$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "ai-image-discard-button",
        spacing: "compact",
        onClick: handleDiscard,
        isDisabled: userOffline || isRetrying,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07a01d3f99018a4a$var$ButtonText, null, formatMessage($07a01d3f99018a4a$var$i18n.discard))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "ai-image-retry-button",
        spacing: "compact",
        onClick: handleRetry,
        isDisabled: userOffline || isRetrying,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            background: "var(--ds-background-input, #FFFFFF)"
        }
    }, isRetrying ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07a01d3f99018a4a$var$ButtonText, null, formatMessage($07a01d3f99018a4a$var$i18n.retry))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "ai-image-accept-button",
        spacing: "compact",
        appearance: "primary",
        onClick: handleAccept,
        isDisabled: userOffline || isRetrying
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($07a01d3f99018a4a$var$AcceptButtonText, null, formatMessage($07a01d3f99018a4a$var$i18n.accept))))));
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $689140bd887be349$var$UploadingPictureWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.smartSpaceOverviewHeight ?? __cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_13y1ha6": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2uo31fmhAQ _0bjKvDzXzM _39xV02N91d _0jFU0VyPTS _1mT5xdRAKS _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $689140bd887be349$export$4103f8c62b69a0b3 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { hasCoverPicture: hasCoverPicture, openMediaBrowser: openMediaBrowser, onRemoveImage: onRemoveImage, userOffline: userOffline, setIsUploadingPicture: setIsUploadingPicture, isUploadingPicture: isUploadingPicture, handleUnsplashUpload: handleUnsplashUpload, initialPicturePosition: initialPicturePosition, onSaveReposition: onSaveReposition, shouldShowReposition: shouldShowReposition, setShouldShowReposition: setShouldShowReposition, coverPictureState: coverPictureState, floatingToolbarButtonStyle: floatingToolbarButtonStyle, forceUpdate: forceUpdate, contentId: contentId, dynamicCoverImageHeight: dynamicCoverImageHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight, onImageWidthChange: onImageWidthChange, spaceKey: spaceKey, isFixedWidthImageOption: isFixedWidthImageOption, generateAIHeaderImage: generateAIHeaderImage, shouldShowAIImageAcceptanceFlow: shouldShowAIImageAcceptanceFlow, onAcceptAIGeneratedImage: onAcceptAIGeneratedImage, onRetryAIGeneratedImage: onRetryAIGeneratedImage, isRetryingAIImage: isRetryingAIImage, isRoundedCorners: isRoundedCorners, analyticsSource: analyticsSource } = t0;
    const [isModalOpenState, setIsModalOpenState] = (0, $cozmU.useState)(false);
    const [isRepositionActive, setIsRepositionActive] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [initialUnsplashInfoArray, setInitialUnsplashInfoArray] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] !== coverPictureState) {
        t2 = ()=>{
            setIsModalOpenState(true);
            coverPictureState.setIsModalOpen(true);
        };
        $[1] = coverPictureState;
        $[2] = t2;
    } else t2 = $[2];
    const openModal = t2;
    let t3;
    if ($[3] !== coverPictureState) {
        t3 = ()=>{
            setIsModalOpenState(false);
            coverPictureState.setIsModalOpen(false);
        };
        $[3] = coverPictureState;
        $[4] = t3;
    } else t3 = $[4];
    const closeModal = t3;
    if (isUploadingPicture && coverPictureState.state.isUploadingPicture) {
        let t4;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "medium"
            });
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== dynamicCoverImageHeight || $[7] !== hasCoverPicture || $[8] !== smartSpaceOverviewHeight) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689140bd887be349$var$UploadingPictureWrapper, {
                "data-testid": "uploading-picture-wrapper",
                hasCoverPicture: hasCoverPicture,
                dynamicCoverImageHeight: dynamicCoverImageHeight,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight
            }, t4);
            $[6] = dynamicCoverImageHeight;
            $[7] = hasCoverPicture;
            $[8] = smartSpaceOverviewHeight;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    } else if (shouldShowAIImageAcceptanceFlow && hasCoverPicture) {
        let t4;
        if ($[10] !== analyticsSource || $[11] !== coverPictureState || $[12] !== dynamicCoverImageHeight || $[13] !== forceUpdate || $[14] !== initialPicturePosition || $[15] !== isRetryingAIImage || $[16] !== onAcceptAIGeneratedImage || $[17] !== onRemoveImage || $[18] !== onRetryAIGeneratedImage || $[19] !== onSaveReposition || $[20] !== userOffline) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $07a01d3f99018a4a$export$33aaeca88e7c46bf), {
                initialPicturePosition: initialPicturePosition,
                onSaveReposition: onSaveReposition,
                onAccept: onAcceptAIGeneratedImage,
                onDiscard: onRemoveImage,
                onRetry: onRetryAIGeneratedImage,
                isRetrying: isRetryingAIImage,
                coverPictureState: coverPictureState,
                forceUpdate: forceUpdate,
                userOffline: userOffline,
                dynamicCoverImageHeight: dynamicCoverImageHeight,
                analyticsSource: analyticsSource
            });
            $[10] = analyticsSource;
            $[11] = coverPictureState;
            $[12] = dynamicCoverImageHeight;
            $[13] = forceUpdate;
            $[14] = initialPicturePosition;
            $[15] = isRetryingAIImage;
            $[16] = onAcceptAIGeneratedImage;
            $[17] = onRemoveImage;
            $[18] = onRetryAIGeneratedImage;
            $[19] = onSaveReposition;
            $[20] = userOffline;
            $[21] = t4;
        } else t4 = $[21];
        return t4;
    } else {
        if ((isRepositionActive || shouldShowReposition || !!coverPictureState.state.shouldShowReposition) && hasCoverPicture) {
            let t4;
            if ($[22] !== analyticsSource || $[23] !== coverPictureState || $[24] !== dynamicCoverImageHeight || $[25] !== forceUpdate || $[26] !== initialPicturePosition || $[27] !== onSaveReposition || $[28] !== setShouldShowReposition || $[29] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46b253a18b421305$export$78e1d98d4f84631f), {
                    initialPicturePosition: initialPicturePosition,
                    onSaveReposition: onSaveReposition,
                    setIsRepositionActive: setIsRepositionActive,
                    setShouldShowReposition: setShouldShowReposition,
                    coverPictureState: coverPictureState,
                    forceUpdate: forceUpdate,
                    userOffline: userOffline,
                    dynamicCoverImageHeight: dynamicCoverImageHeight,
                    analyticsSource: analyticsSource
                });
                $[22] = analyticsSource;
                $[23] = coverPictureState;
                $[24] = dynamicCoverImageHeight;
                $[25] = forceUpdate;
                $[26] = initialPicturePosition;
                $[27] = onSaveReposition;
                $[28] = setShouldShowReposition;
                $[29] = userOffline;
                $[30] = t4;
            } else t4 = $[30];
            return t4;
        } else if (hasCoverPicture) {
            let t4;
            if ($[31] !== analyticsSource || $[32] !== closeModal || $[33] !== contentId || $[34] !== coverPictureState || $[35] !== dynamicCoverImageHeight || $[36] !== generateAIHeaderImage || $[37] !== handleUnsplashUpload || $[38] !== initialUnsplashInfoArray || $[39] !== isFixedWidthImageOption || $[40] !== isRoundedCorners || $[41] !== onImageWidthChange || $[42] !== onRemoveImage || $[43] !== openMediaBrowser || $[44] !== setIsUploadingPicture || $[45] !== smartSpaceOverviewHeight || $[46] !== spaceKey || $[47] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d56946553982f95c$export$d83b52f1c3c4071e), {
                    userOffline: userOffline,
                    closeModal: closeModal,
                    openMediaBrowser: openMediaBrowser,
                    setIsRepositionActive: setIsRepositionActive,
                    onRemoveImage: onRemoveImage,
                    handleUnsplashUpload: handleUnsplashUpload,
                    setIsUploadingPicture: setIsUploadingPicture,
                    initialUnsplashInfoArray: initialUnsplashInfoArray,
                    setInitialUnsplashInfoArray: setInitialUnsplashInfoArray,
                    coverPictureState: coverPictureState,
                    contentId: contentId,
                    onImageWidthChange: onImageWidthChange,
                    spaceKey: spaceKey,
                    dynamicCoverImageHeight: dynamicCoverImageHeight,
                    smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    generateAIHeaderImage: generateAIHeaderImage,
                    isRoundedCorners: isRoundedCorners,
                    analyticsSource: analyticsSource
                });
                $[31] = analyticsSource;
                $[32] = closeModal;
                $[33] = contentId;
                $[34] = coverPictureState;
                $[35] = dynamicCoverImageHeight;
                $[36] = generateAIHeaderImage;
                $[37] = handleUnsplashUpload;
                $[38] = initialUnsplashInfoArray;
                $[39] = isFixedWidthImageOption;
                $[40] = isRoundedCorners;
                $[41] = onImageWidthChange;
                $[42] = onRemoveImage;
                $[43] = openMediaBrowser;
                $[44] = setIsUploadingPicture;
                $[45] = smartSpaceOverviewHeight;
                $[46] = spaceKey;
                $[47] = userOffline;
                $[48] = t4;
            } else t4 = $[48];
            return t4;
        } else {
            let t4;
            if ($[49] !== analyticsSource || $[50] !== closeModal || $[51] !== contentId || $[52] !== coverPictureState || $[53] !== floatingToolbarButtonStyle || $[54] !== generateAIHeaderImage || $[55] !== handleUnsplashUpload || $[56] !== initialUnsplashInfoArray || $[57] !== isModalOpenState || $[58] !== openMediaBrowser || $[59] !== openModal || $[60] !== setIsUploadingPicture || $[61] !== userOffline) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b276f472a35f7217$export$97958e565d90ce0a), {
                    userOffline: userOffline,
                    openModal: openModal,
                    closeModal: closeModal,
                    openMediaBrowser: openMediaBrowser,
                    isModalOpenState: isModalOpenState,
                    handleUnsplashUpload: handleUnsplashUpload,
                    setIsUploadingPicture: setIsUploadingPicture,
                    initialUnsplashInfoArray: initialUnsplashInfoArray,
                    setInitialUnsplashInfoArray: setInitialUnsplashInfoArray,
                    coverPictureState: coverPictureState,
                    floatingToolbarButtonStyle: floatingToolbarButtonStyle,
                    contentId: contentId,
                    generateAIHeaderImage: generateAIHeaderImage,
                    analyticsSource: analyticsSource
                });
                $[49] = analyticsSource;
                $[50] = closeModal;
                $[51] = contentId;
                $[52] = coverPictureState;
                $[53] = floatingToolbarButtonStyle;
                $[54] = generateAIHeaderImage;
                $[55] = handleUnsplashUpload;
                $[56] = initialUnsplashInfoArray;
                $[57] = isModalOpenState;
                $[58] = openMediaBrowser;
                $[59] = openModal;
                $[60] = setIsUploadingPicture;
                $[61] = userOffline;
                $[62] = t4;
            } else t4 = $[62];
            return t4;
        }
    }
});




















const $4dbf19c0ece58c9f$var$styles = {
    base: "_3iDTPbQ4SZ _39xV02N91d _1mT5xdWVPG",
    loading: "_1mT5xdRAKS _39xV02N91d _0KLXrumhAQ",
    noOpacity: "_1YKVNsdnbC",
    opacity: "_1YKVNs7dHp"
}; // TODO: remove when cleaning up confluence_page_cover_picture_css_migration
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbf19c0ece58c9f$var$AllowedExternalLoadingDivStyled = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, dynamicCoverImageHeight: dynamicCoverImageHeight, hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px"),
                "--_pjvxvw": (0, $9aYkv.default)(__cmplp.dynamicCoverImageHeight, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2uo31fmhAQ _0bjKvDZqHV _1mT5xdRAKS _39xV02N91d",
                __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : "_0jFU0VYOrR",
                __cmplp.hasAllowedExternalImageLoaded ? "_1YKVNsdnbC" : "_1YKVNs7dHp",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $4dbf19c0ece58c9f$var$getMinHeightStyle = (isFixedWidthImageOption, smartSpaceOverviewHeight)=>{
    if (smartSpaceOverviewHeight) return `${smartSpaceOverviewHeight}px`;
    if (isFixedWidthImageOption) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    return `${0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT}px`;
     // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    return `${0, $75Ax4.CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE}px`;
};
const $4dbf19c0ece58c9f$var$AllowedExternalWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, children: children } = t0;
    let t1;
    if ($[0] !== isFixedWidthImageOption || $[1] !== smartSpaceOverviewHeight) {
        t1 = $4dbf19c0ece58c9f$var$getMinHeightStyle(isFixedWidthImageOption, smartSpaceOverviewHeight);
        $[0] = isFixedWidthImageOption;
        $[1] = smartSpaceOverviewHeight;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = {
            minHeight: t1
        };
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $4dbf19c0ece58c9f$var$styles.base
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== children || $[7] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t2,
            "data-testid": "unsplash-wrapper-css",
            className: t3
        }, children);
        $[6] = children;
        $[7] = t2;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
const $4dbf19c0ece58c9f$var$AllowedExternalLoadingDiv = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded, dynamicCoverImageHeight: dynamicCoverImageHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight } = t0;
    if ((0, $6mKj3.expValEquals)("confluence_page_cover_picture_css_migration", "isEnabled", true)) {
        const t1 = smartSpaceOverviewHeight ? `${smartSpaceOverviewHeight}px` : dynamicCoverImageHeight ? `${dynamicCoverImageHeight}px` : undefined;
        let t2;
        if ($[0] !== t1) {
            t2 = {
                height: t1
            };
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        const t3 = hasAllowedExternalImageLoaded ? $4dbf19c0ece58c9f$var$styles.noOpacity : $4dbf19c0ece58c9f$var$styles.opacity;
        let t4;
        if ($[2] !== t3) {
            t4 = (0, $hekY6.default)([
                $4dbf19c0ece58c9f$var$styles.loading,
                t3
            ]);
            $[2] = t3;
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== t2 || $[5] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                style: t2,
                "data-testid": "unsplash-loading-div-css",
                className: t4
            });
            $[4] = t2;
            $[5] = t4;
            $[6] = t5;
        } else t5 = $[6];
        return t5;
    }
    let t1;
    if ($[7] !== dynamicCoverImageHeight || $[8] !== hasAllowedExternalImageLoaded || $[9] !== smartSpaceOverviewHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dbf19c0ece58c9f$var$AllowedExternalLoadingDivStyled, {
            hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            "data-testid": "unsplash-loading-div"
        });
        $[7] = dynamicCoverImageHeight;
        $[8] = hasAllowedExternalImageLoaded;
        $[9] = smartSpaceOverviewHeight;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
};
const $4dbf19c0ece58c9f$export$8e0ec3f3e7cffe52 = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { coverPicture: coverPicture, dynamicCoverImageHeight: dynamicCoverImageHeight, isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, coverPictureDataPosition: coverPictureDataPosition, coverPictureDataId: coverPictureDataId, isRoundedCorners: isRoundedCorners } = t0;
    const [hasAllowedExternalImageLoaded, setHasAllowedExternalImageLoaded] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== dynamicCoverImageHeight || $[1] !== hasAllowedExternalImageLoaded || $[2] !== smartSpaceOverviewHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dbf19c0ece58c9f$var$AllowedExternalLoadingDiv, {
            hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight
        });
        $[0] = dynamicCoverImageHeight;
        $[1] = hasAllowedExternalImageLoaded;
        $[2] = smartSpaceOverviewHeight;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = coverPicture.current.draft?.value.id ?? coverPictureDataId;
    const t3 = coverPicture.current.draft?.value.position ?? coverPictureDataPosition;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setHasAllowedExternalImageLoaded(true);
        };
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== isFixedWidthImageOption || $[6] !== isRoundedCorners || $[7] !== smartSpaceOverviewHeight || $[8] !== t2 || $[9] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66db09fad5336912$export$75f07c36086c2c81), {
            "data-testid": "unsplash-cover-picture",
            id: "actual-cover-picture",
            "data-vc": "unsplash-cover-picture-editor",
            src: t2,
            coverPicturePosition: t3,
            onLoad: t4,
            isFixedWidthImageOption: isFixedWidthImageOption,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            isRoundedCorners: isRoundedCorners,
            className: "cover-picture-wrapper-dangerously-set-inner-html"
        });
        $[5] = isFixedWidthImageOption;
        $[6] = isRoundedCorners;
        $[7] = smartSpaceOverviewHeight;
        $[8] = t2;
        $[9] = t3;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== dynamicCoverImageHeight || $[12] !== hasAllowedExternalImageLoaded || $[13] !== isFixedWidthImageOption || $[14] !== smartSpaceOverviewHeight || $[15] !== t1 || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dbf19c0ece58c9f$var$AllowedExternalWrapper, {
            hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            isFixedWidthImageOption: isFixedWidthImageOption,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            "data-testid": "unsplash-wrapper"
        }, t1, t5);
        $[11] = dynamicCoverImageHeight;
        $[12] = hasAllowedExternalImageLoaded;
        $[13] = isFixedWidthImageOption;
        $[14] = smartSpaceOverviewHeight;
        $[15] = t1;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
};











/* EditorPageCoverPictureWrapperCss.tsx generated by @compiled/babel-plugin v3.0.2 */ 





const $27bd5511d1f80242$var$COVER_IMAGE_FIXED_HEIGHT = 147;
const $27bd5511d1f80242$var$SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH = 200;
const $27bd5511d1f80242$var$styles = {
    base: "_1mT5xdRAKS _1DCdHi2ADO",
    noMargin: "_313842Pgdg _1DCdHiPgdg",
    pointer: "_0wOv4Q7zJH",
    auto: "_0wOv4QIZbP",
    withPicture: "_313842gVvo",
    withoutPicture: "_313842Pgdg",
    hidden: "_0jFU0VdnbC",
    fixedWidth: "_0jFU0V6Tex",
    smartSpaceOverviewHeight: "_0jFU0VgZxp",
    scaledWidth: "_0jFU0VbQHl"
};
const $27bd5511d1f80242$export$67a89e1eb110a1d7 = ({ hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, isReadOnly: isReadOnly, isFixedWidthImageOption: isFixedWidthImageOption, isSmartSpaceOverview: isSmartSpaceOverview, width: width, children: children, ...props })=>{
    'use no memo'; // Exclude from React compiler - breaks unit tests when component uses compiled CSS
    // Dynamic width - must use style prop
    const computedWidth = (0, $cozmU.useMemo)(()=>{
        if ((hasCoverPicture || isUploadingPicture) && isFixedWidthImageOption) return '800px';
        if ((hasCoverPicture || isUploadingPicture) && !isFixedWidthImageOption) return '100%';
        if ((hasCoverPicture || isUploadingPicture) && width) return `${width}px`;
        return '100%';
    }, [
        hasCoverPicture,
        isUploadingPicture,
        isFixedWidthImageOption,
        width
    ]);
    const hasPicture = hasCoverPicture || isUploadingPicture;
    const showPictureMargin = !isSmartSpaceOverview && hasPicture;
    const showNoPictureMargin = !isSmartSpaceOverview && !hasPicture;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        style: {
            width: computedWidth
        },
        className: (0, $hekY6.default)([
            $27bd5511d1f80242$var$styles.base,
            isSmartSpaceOverview && $27bd5511d1f80242$var$styles.noMargin,
            isReadOnly ? $27bd5511d1f80242$var$styles.auto : $27bd5511d1f80242$var$styles.pointer,
            showPictureMargin && $27bd5511d1f80242$var$styles.withPicture,
            showNoPictureMargin && $27bd5511d1f80242$var$styles.withoutPicture,
            !hasPicture ? $27bd5511d1f80242$var$styles.hidden : isSmartSpaceOverview ? $27bd5511d1f80242$var$styles.smartSpaceOverviewHeight : isFixedWidthImageOption ? $27bd5511d1f80242$var$styles.fixedWidth : $27bd5511d1f80242$var$styles.scaledWidth
        ])
    }, children);
};













const $ae649144a67a3966$var$COVER_IMAGE_FIXED_HEIGHT = 147;
const $ae649144a67a3966$export$825ca283ddb318c2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { hasCoverPicture: hasCoverPicture, isUploadingPicture: isUploadingPicture, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, isSmartSpaceOverview: isSmartSpaceOverview, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px"),
                "--_pjvxvw": (0, $9aYkv.default)(__cmplp.dynamicCoverImageHeight, "px"),
                "--_1vcp0mh": (0, $9aYkv.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_0bjKvDZqHV _1mT5xdRAKS",
                (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && !__cmplp.isFixedWidthImageOption ? "_0jFU0VbQHl" : __cmplp.hasCoverPicture || __cmplp.isUploadingPicture ? "_0jFU0VYOrR" : "_0jFU0VdnbC",
                (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.isFixedWidthImageOption ? "_39xV02OAqP" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && !__cmplp.isFixedWidthImageOption ? "_39xV02N91d" : (__cmplp.hasCoverPicture || __cmplp.isUploadingPicture) && __cmplp.width ? "_39xV02nyX9" : "_39xV02N91d",
                !__cmplp.isReadOnly ? "_0wOv4Q7zJH" : "_0wOv4QIZbP",
                __cmplp.isSmartSpaceOverview ? "_1DCdHiPgdg" : "_1DCdHi2ADO",
                __cmplp.isSmartSpaceOverview ? "_313842Pgdg" : __cmplp.hasCoverPicture || __cmplp.isUploadingPicture ? "_313842gVvo" : "_313842Pgdg",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});


const $4d3478acd5148f8b$export$7291ee1cb3635b5b = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if ((0, $6mKj3.expValEquals)("confluence_page_cover_picture_css_migration", "isEnabled", true)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $27bd5511d1f80242$export$67a89e1eb110a1d7), props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ae649144a67a3966$export$825ca283ddb318c2), props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};


const $e4cacfdae9b2fb53$var$i18n = (0, $kSwu1.defineMessages)({
    errorFlagTitle: {
        id: "page-cover-picture.error.flag.title",
        defaultMessage: "We can\u2019t upload your header image"
    },
    errorFlagDescription: {
        id: "page-cover-picture.error.flag.description",
        defaultMessage: "Refresh and try again."
    },
    aiGenerationErrorFlagTitle: {
        id: "page-cover-picture.ai-generation.error.flag.title",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We couldn't generate your header image"
    },
    aiGenerationErrorFlagDescription: {
        id: "page-cover-picture.ai-generation.error.flag.description",
        defaultMessage: "Try again or choose a different image."
    },
    aiGenerationErrorFlagDescriptionWithReason: {
        id: "page-cover-picture.ai-generation.error.flag.description-with-reason",
        defaultMessage: "{errorReason}. Try again or choose a different image."
    }
});
const $e4cacfdae9b2fb53$var$hasCoverPictureChanged = (currentDraft, nextDraft)=>currentDraft?.value?.id !== nextDraft?.value?.id || currentDraft?.value?.position !== nextDraft?.value?.position || currentDraft?.version !== nextDraft?.version;
const $e4cacfdae9b2fb53$var$EditorPageCoverPictureComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, hasCoverPicture: hasCoverPicture, contentPropertyKey: contentPropertyKey, isSmartSpaceOverview: isSmartSpaceOverview, coverPictureState: coverPictureState, isUnpublishedDraft: isUnpublishedDraft, flags: flags, floatingToolbarButtonStyle: floatingToolbarButtonStyle, width: width, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, spaceKey: spaceKey, isFixedWidthImageOption: isFixedWidthImageOption, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageError: aiHeaderImageError, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, isSmartCreate: isSmartCreate })=>{
    const isGCP = (0, $cTZvm.isGoogleCloudPlatform)();
    const [isMediaBrowserOpen, setIsMediaBrowserOpen] = (0, $cozmU.useState)(false);
    const { isExternalShareRequest: isExternalShare } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    const [isUploadingPicture, setIsUploadingPicture] = (0, $cozmU.useState)(false);
    const [regenerationCount, setRegenerationCount] = (0, $cozmU.useState)(0);
    // mediaConfig does not use onUploadRejection when in read only (RendererMediaProvider), but does need it otherwise (EditorMediaProvider).
    const [mediaConfig, setMediaConfig] = (0, $cozmU.useState)(null);
    // Using ref since onHandleUploadEnd event uses previous cover picture information and upload will fail
    // since the information is from the past render
    const coverPicture = (0, $cozmU.useRef)({
        draft: null
    });
    const [optimisticMediaCoverPictureId, setOptimisticMediaCoverPictureId] = (0, $cozmU.useState)(null);
    // need this force update since we are using useRef for the cover picture and therefore won't update the image automatically on change
    const [, forceUpdate] = (0, $cozmU.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // need this state since we want to show reposition option right after we upload a photo
    const [shouldShowReposition, setShouldShowReposition] = (0, $cozmU.useState)(false);
    // AI Image Acceptance Flow state
    const [isRetryingAIImage, setIsRetryingAIImage] = (0, $cozmU.useState)(false);
    // Track previous status to detect transition from LOADING_WITH_ACCEPTANCE_FLOW
    const prevAIHeaderImageStatusRef = (0, $cozmU.useRef)(undefined);
    // Track previous status to detect transition INTO ERROR state (for showing error flag)
    const prevStatusForErrorFlagRef = (0, $cozmU.useRef)(aiHeaderImageStatus ?? null);
    const ssrConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        isExternalShare: isExternalShare
    });
    const isServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)(true);
    const hasSSRConfigInSSRModeOrHydration = Boolean((isServerPlaceholder || window.__SSR_RENDERED__) && ssrConfig);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const intl = (0, $kSwu1.useIntl)();
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    const analyticsSource = isSmartSpaceOverview ? 'smartSpaceOverview' : 'editorPageCoverPicture';
    const { updateContentProperty: updateContentProperty } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page',
        options: {
            refetchQueries: ()=>[
                    {
                        query: (0, $lC6Qd.default),
                        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? (0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                            contentId: contentId,
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        }) : {
                            contentId: contentId,
                            status: [
                                'draft'
                            ],
                            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                        }
                    }
                ]
        }
    });
    const coverPictureFragmentResult = (0, $bCpIa.useCoverPictureFragment)({
        contentId: contentId
    });
    const coverPictureQueryResult = (0, $jMyy4.useQueryInterop)((0, $lC6Qd.default), {
        context: {
            single: true
        },
        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? (0, $g6QPm.createEditorContentUnifiedQueryVariables)({
            contentId: contentId,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        }) : {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        skip: coverPictureFragmentResult.isProvided,
        __callerPackage__: "page-cover-picture"
    });
    const { data: data } = coverPictureFragmentResult.isProvided ? coverPictureFragmentResult : coverPictureQueryResult;
    // The skipped query's refetch writes the records the fragment reads, so it updates the fragment.
    const { refetch: refetch } = coverPictureQueryResult;
    const updateCoverPicture = (0, $cozmU.useCallback)(()=>{
        const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
        const draft = properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT);
        const published = properties.find((p_0)=>p_0?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
        // Smart Space Overview: when mutating PUBLISHED (no draft), display from published
        const propertyToUse = contentPropertyKey === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED ? published : draft;
        const nextDraft = (0, $3WPGR.propertyToId)(propertyToUse);
        if (coverPictureState.state.hasCoverPicture && coverPicture.current?.draft?.value?.id && !nextDraft && isGCP) return;
        coverPicture.current = {
            draft: nextDraft
        };
    }, [
        data,
        contentPropertyKey,
        coverPictureState.state.hasCoverPicture,
        isGCP
    ]);
    const coverPictureData = (0, $3WPGR.getRendererCoverPictureInfo)(data, isLivePage);
    const coverPictureDataId = coverPictureData?.coverPicture?.published?.value?.id;
    // Need this since the isUnsplash prop isn't getting the up to date values
    // Check if the cover picture is from Unsplash or Atlassian hosted CDN (dam-cdn or wac-cdn)
    const coverPictureId = coverPicture.current?.draft?.value?.id;
    // Setting this to null so that createLiveDocHeaderImageAnalyticsEvent is not fired until
    // isAllowedExternalCoverPicture is set to either true/false
    const isAllowedExternalCoverPicture = coverPictureId === undefined ? null : (0, $3WPGR.isAllowedExternalCoverPictureUrl)(coverPictureId);
    const isGeneratingHeaderImage = aiHeaderImageStatus === 'LOADING' || aiHeaderImageStatus === 'LOADING_WITH_ACCEPTANCE_FLOW';
    const [mutateCoverPictureWidth] = (0, $308Wd.useMutationInterop)((0, $50da084713014cf6$export$2e2bcd8739ae039), {
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
            });
        },
        __callerPackage__: "page-cover-picture"
    });
    const onCoverPictureUpdatedSubscriptionData = (0, $cozmU.useCallback)(async (_, response)=>{
        try {
            await refetch();
            const { coverPictureUpdated: coverPictureUpdated } = response || {};
            const value = JSON.parse(coverPictureUpdated?.value);
            const version = coverPictureUpdated?.version;
            coverPicture.current['draft'] = {
                value: value,
                version: version
            };
            coverPictureState.setHasCoverPicture(true);
            setIsUploadingPicture(false);
            coverPictureState.setIsUploadingPicture(false);
            coverPictureState.setCoverPictureId(value.id);
            forceUpdate(Math.random());
        } catch (error_0) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_0, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_0);
        }
    }, [
        refetch,
        coverPictureState
    ]);
    const onCoverPictureWidthUpdatedSubscription = (0, $cozmU.useCallback)((__0, response_0)=>{
        const { coverPictureWidthUpdated: coverPictureWidthUpdated } = response_0 || {};
        const value_0 = coverPictureWidthUpdated?.coverPictureWidth;
        coverPictureState.toggleCoverPictureWidthButton(value_0);
        forceUpdate(Math.random());
    }, [
        coverPictureState
    ]);
    const onCoverPictureDeletedSubscription = (0, $cozmU.useCallback)(async ()=>{
        try {
            await refetch();
            coverPicture.current['draft'] = null;
            coverPictureState.setHasCoverPicture(false);
            coverPictureState.setCoverPictureId(null);
            coverPictureState.setIsModalOpen(false);
            coverPictureState.setIsAddHeaderImageButtonFocused(false);
            forceUpdate(Math.random());
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        refetch,
        coverPictureState
    ]);
    // Smart Space Overview: subscriptions don't fire, so refetch after mutations
    const refetchAfterMutation = (0, $cozmU.useCallback)(async ()=>{
        try {
            await refetch();
            forceUpdate(Math.random());
        } catch (error_2) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_2, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_2);
        }
    }, [
        refetch
    ]);
    const subscriptionResourceType = contentType || 'page';
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditingCoverPictureSubscription',
        contentId: contentId,
        delta: 'coverPictureUpdated',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureUpdatedSubscriptionData
    });
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorCoverPictureDeletedSubscription',
        contentId: contentId,
        delta: 'coverPictureDeleted',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureDeletedSubscription
    });
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'EditorCoverPictureWidthUpdatedSubscription',
        contentId: contentId,
        delta: 'coverPictureWidthUpdated',
        contentType: subscriptionResourceType,
        onDataReceived: onCoverPictureWidthUpdatedSubscription
    });
    const propertyKeyForMutations = contentPropertyKey ?? (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT;
    // Check for existing cover picture
    (0, $cozmU.useEffect)(()=>{
        if ((0, $3gyyc.isSSRStreaming)()) updateCoverPicture();
        else {
            const properties_0 = data?.content?.nodes?.[0]?.properties?.nodes || [];
            const draft_0 = properties_0.find((p_1)=>p_1?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT);
            const published_0 = properties_0.find((p_2)=>p_2?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
            // Smart Space Overview: when mutating PUBLISHED (no draft), display from published
            const propertyToUse_0 = contentPropertyKey === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED ? published_0 : draft_0;
            const nextDraft_0 = (0, $3WPGR.propertyToId)(propertyToUse_0);
            if (coverPictureState.state.hasCoverPicture && coverPicture.current?.draft?.value?.id && !nextDraft_0 && isGCP) {
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                if (!(0, $9wGTI.fg)('confluence_cover_pic_draft_sync_guard')) forceUpdate(Math.random());
                return;
            }
            if (!$e4cacfdae9b2fb53$var$hasCoverPictureChanged(coverPicture.current.draft, nextDraft_0) && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            (0, $9wGTI.fg)('confluence_cover_pic_draft_sync_guard')) return;
            coverPicture.current = {
                draft: nextDraft_0
            };
        }
        forceUpdate(Math.random());
    }, [
        data,
        contentId,
        contentPropertyKey,
        updateCoverPicture,
        isGCP,
        coverPictureState.state.hasCoverPicture
    ]);
    // Setup media config
    (0, $cozmU.useEffect)(()=>{
        const showAttachmentLimitReachedFlag = (rejectionData)=>{
            if (flags && rejectionData) flags.showErrorFlag((0, $2vVvv.getAttachmentSizeLimitErrorFlag)(rejectionData, intl)).then(()=>{
                setIsUploadingPicture(false);
                coverPictureState.setIsUploadingPicture(false);
                experienceTracker.abort({
                    name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE),
                    reason: 'Cover picture media upload too large'
                });
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCoverPictureAttachmentTooLargeFlag'
                    }
                }).fire();
            });
            return !!rejectionData;
        };
        // If read only, use renderer media provider, as we only need the auth provider from rendererMediaProvider, and user without edit perms (read only) doesn't have access to editorMediaProvider APIs
        // If not read only, use editor media provider
        const createMediaConfig = async ()=>{
            if (isReadOnly) {
                const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                    contentId: contentId,
                    isExternalShare: false
                });
                if (!viewMediaClientConfig) return null;
                setMediaConfig({
                    collection: `contentId-${contentId}`,
                    authProvider: viewMediaClientConfig.authProvider
                });
            } else {
                const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = await (0, $4IoVL.createEditorMediaProvider)({
                    contentId: contentId,
                    contentType: 'page',
                    isExternalShare: isExternalShare,
                    onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
                });
                if (uploadMediaClientConfig == undefined) return null;
                setMediaConfig({
                    collection: uploadParams?.collection,
                    authProvider: uploadMediaClientConfig.authProvider,
                    onUploadRejection: uploadParams?.onUploadRejection,
                    useSha256ForUploads: uploadMediaClientConfig?.useSha256ForUploads
                });
            }
        };
        createMediaConfig();
    }, [
        contentId,
        isExternalShare,
        flags,
        intl,
        coverPictureState,
        createAnalyticsEvent,
        experienceTracker,
        isReadOnly
    ]);
    // handling user publishes - we only need to worry about firing the analytic event as backend will take care of the
    // published cover picture content property mutation due to scheduled publishes
    (0, $cozmU.useEffect)(()=>{
        // fire analytic if we're publishing a page with a cover image
        if (isPublishingContent && !!coverPicture.current?.draft?.value.id) {
            if (isUnpublishedDraft) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdWithHeaderImage',
                    actionSubject: 'page',
                    objectId: contentId,
                    source: analyticsSource
                }
            }).fire();
            else createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'updatedWithHeaderImage',
                    actionSubject: 'page',
                    objectId: contentId,
                    source: analyticsSource
                }
            }).fire();
        }
    }, [
        contentId,
        isPublishingContent,
        isUnpublishedDraft,
        createAnalyticsEvent,
        analyticsSource
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isPublishingContent && hasCoverPicture) coverPictureState.setShouldShowReposition(false);
    }, [
        hasCoverPicture,
        isPublishingContent,
        coverPictureState
    ]);
    const showErrorFlag = ()=>{
        flags.showFlag({
            type: 'error',
            title: formatMessage($e4cacfdae9b2fb53$var$i18n.errorFlagTitle),
            description: formatMessage($e4cacfdae9b2fb53$var$i18n.errorFlagDescription),
            messageType: 'transactional',
            messageId: 'page-cover-picture-error-flag'
        });
        setIsUploadingPicture(false);
        coverPictureState.setIsUploadingPicture(false);
        experienceTracker.stopOnError({
            name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE),
            error: new Error('Error with cover picture media upload')
        });
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'pageCoverPictureErrorFlag'
            }
        }).fire();
    };
    const showAIGenerationErrorFlag = (0, $cozmU.useCallback)((errorReason)=>{
        // Use the API error reason if available, otherwise fall back to generic message
        const description = errorReason ? formatMessage($e4cacfdae9b2fb53$var$i18n.aiGenerationErrorFlagDescriptionWithReason, {
            errorReason: errorReason
        }) : formatMessage($e4cacfdae9b2fb53$var$i18n.aiGenerationErrorFlagDescription);
        flags.showFlag({
            type: 'error',
            title: formatMessage($e4cacfdae9b2fb53$var$i18n.aiGenerationErrorFlagTitle),
            description: description,
            messageType: 'transactional',
            messageId: 'page-cover-picture-ai-generation-error-flag'
        });
        // Clear loading states
        setIsUploadingPicture(false);
        coverPictureState.setIsUploadingPicture(false);
        setIsRetryingAIImage(false);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'pageCoverPictureAIGenerationErrorFlag',
                attributes: {
                    errorReason: errorReason || 'unknown'
                }
            }
        }).fire();
    }, [
        flags,
        formatMessage,
        coverPictureState,
        createAnalyticsEvent
    ]);
    const handleUploadStart = ()=>{
        setIsUploadingPicture(true);
        coverPictureState.setIsUploadingPicture(true);
        coverPictureState.setIsChangingPicture(false);
        experienceTracker.start({
            name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE)
        });
    };
    const handleUploadEnd = (event)=>{
        const fileType = event.file.type;
        const id = event?.file?.id;
        if (!fileType.includes('image')) showErrorFlag();
        else if (id) {
            const currentAIFCAutoImage = coverPictureState.state.isCurrentAIFCAutoImage;
            // must JSON stringify propertyValue object since mutation expects a string for this parameter
            const propertyValue = JSON.stringify({
                id: id,
                position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
            });
            const updatePromise = updateContentProperty({
                propertyKey: propertyKeyForMutations,
                propertyValue: propertyValue,
                isDelete: false,
                hasExistingProperty: hasCoverPicture
            });
            if (isSmartSpaceOverview && updatePromise) updatePromise.then(()=>{
                refetchAfterMutation();
                setIsUploadingPicture(false);
                coverPictureState.setIsUploadingPicture(false);
            });
            else if (updatePromise && isGCP) {
                coverPicture.current['draft'] = {
                    value: {
                        id: id,
                        position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
                    },
                    version: (coverPicture.current?.draft?.version || 0) + 1
                };
                coverPictureState.setCoverPictureId(id);
                coverPictureState.setHasCoverPicture(true);
                setOptimisticMediaCoverPictureId(id);
                forceUpdate(Math.random());
                updatePromise.then(async ()=>{
                    forceUpdate(Math.random());
                    try {
                        await refetch();
                    } catch (error_3) {
                        (0, $5ZqQS.getMonitoringClient)().submitError(error_3, {
                            attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                        });
                        (0, $7Sm4c.markErrorAsHandled)(error_3);
                    } finally{
                        setIsUploadingPicture(false);
                        coverPictureState.setIsUploadingPicture(false);
                    }
                });
            }
            setShouldShowReposition(true);
            coverPictureState.setShouldShowReposition(true);
            coverPictureState.setIsCurrentAIFCAutoImage(false);
            experienceTracker.succeed({
                name: (0, $irVI7.COVER_PICTURE_MEDIA_UPLOAD_EXPERIENCE)
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'added',
                    actionSubject: 'image',
                    actionSubjectId: 'headerImageAdded',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'uploaded',
                        imageId: id,
                        inputMethod: 'header',
                        isLivePage: isLivePage,
                        isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation'),
                        isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img'),
                        isAIFCAutoGeneratedImage: false
                    }
                }
            }).fire();
            if (currentAIFCAutoImage) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'replaced',
                    actionSubject: 'image',
                    actionSubjectId: 'autoGeneratedAIFCImageReplaced',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'uploaded',
                        inputMethod: 'header',
                        isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation')
                    }
                }
            }).fire();
        } else showErrorFlag();
    };
    const handleUnsplashUpload = (0, $cozmU.useCallback)((photoURL)=>{
        const currentAIFCAutoImage_0 = coverPictureState.state.isCurrentAIFCAutoImage;
        setIsUploadingPicture(true);
        coverPictureState.setIsUploadingPicture(true);
        const propertyValue_0 = JSON.stringify({
            id: photoURL,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        });
        const updatePromise_0 = updateContentProperty({
            propertyKey: propertyKeyForMutations,
            propertyValue: propertyValue_0,
            isDelete: false,
            hasExistingProperty: hasCoverPicture
        });
        if (isSmartSpaceOverview && updatePromise_0) updatePromise_0.then(()=>{
            refetchAfterMutation();
            setIsUploadingPicture(false);
            coverPictureState.setIsUploadingPicture(false);
        });
        else if (updatePromise_0 && isGCP) {
            coverPicture.current['draft'] = {
                value: {
                    id: photoURL,
                    position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
                },
                version: (coverPicture.current?.draft?.version || 0) + 1
            };
            coverPictureState.setCoverPictureId(photoURL);
            coverPictureState.setHasCoverPicture(true);
            forceUpdate(Math.random());
            updatePromise_0.then(async ()=>{
                forceUpdate(Math.random());
                try {
                    await refetch();
                } catch (error_4) {
                    (0, $5ZqQS.getMonitoringClient)().submitError(error_4, {
                        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                    });
                    (0, $7Sm4c.markErrorAsHandled)(error_4);
                } finally{
                    setIsUploadingPicture(false);
                    coverPictureState.setIsUploadingPicture(false);
                }
            });
        }
        setShouldShowReposition(true);
        coverPictureState.setShouldShowReposition(true);
        coverPictureState.setIsCurrentAIFCAutoImage(false);
        experienceTracker.succeed({
            name: (0, $irVI7.COVER_PICTURE_UNSPLASH_UPLOAD_EXPERIENCE)
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'headerImageAdded',
                source: analyticsSource,
                attributes: {
                    imageSource: 'unsplash',
                    imageId: photoURL,
                    inputMethod: 'header',
                    isLivePage: isLivePage,
                    isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation'),
                    isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img'),
                    isAIFCAutoGeneratedImage: false
                }
            }
        }).fire();
        if (currentAIFCAutoImage_0) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'replaced',
                actionSubject: 'image',
                actionSubjectId: 'autoGeneratedAIFCImageReplaced',
                source: analyticsSource,
                attributes: {
                    imageSource: 'unsplash',
                    inputMethod: 'header',
                    isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation')
                }
            }
        }).fire();
    }, [
        coverPictureState,
        createAnalyticsEvent,
        experienceTracker,
        isLivePage,
        updateContentProperty,
        hasCoverPicture,
        propertyKeyForMutations,
        isSmartSpaceOverview,
        refetchAfterMutation,
        refetch,
        analyticsSource,
        isGCP
    ]);
    const handleAIGeneratedUpload = (0, $cozmU.useCallback)((mediaFileId, skipStatusUpdate = false, isAIFCAutoGeneratedImage = false)=>{
        const propertyValue_1 = JSON.stringify({
            id: mediaFileId,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        });
        const updatePromise_1 = updateContentProperty({
            propertyKey: propertyKeyForMutations,
            propertyValue: propertyValue_1,
            isDelete: false,
            hasExistingProperty: hasCoverPicture
        });
        if (isSmartSpaceOverview && updatePromise_1) updatePromise_1.then(()=>{
            refetchAfterMutation();
        });
        else if (updatePromise_1 && isGCP) {
            coverPicture.current['draft'] = {
                value: {
                    id: mediaFileId,
                    position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
                },
                version: (coverPicture.current?.draft?.version || 0) + 1
            };
            coverPictureState.setCoverPictureId(mediaFileId);
            coverPictureState.setHasCoverPicture(true);
            setOptimisticMediaCoverPictureId(mediaFileId);
            forceUpdate(Math.random());
            updatePromise_1.then(async ()=>{
                forceUpdate(Math.random());
                try {
                    await refetch();
                } catch (error_5) {
                    (0, $5ZqQS.getMonitoringClient)().submitError(error_5, {
                        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                    });
                    (0, $7Sm4c.markErrorAsHandled)(error_5);
                }
            });
        }
        // Don't set SUCCESSFULLY_SET if we're showing acceptance flow
        // The status will be set when user accepts the image
        if (!skipStatusUpdate) setAIHeaderImageStatus?.('SUCCESSFULLY_SET');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'added',
                actionSubject: 'image',
                actionSubjectId: 'headerImageAdded',
                source: analyticsSource,
                attributes: {
                    imageSource: 'aiGenerated',
                    imageId: mediaFileId,
                    inputMethod: 'header',
                    isLivePage: isLivePage,
                    isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation'),
                    isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img'),
                    isAIFCAutoGeneratedImage: isAIFCAutoGeneratedImage
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isLivePage,
        setAIHeaderImageStatus,
        updateContentProperty,
        hasCoverPicture,
        propertyKeyForMutations,
        isSmartSpaceOverview,
        refetchAfterMutation,
        refetch,
        coverPictureState,
        analyticsSource,
        isGCP
    ]);
    const updateCoverPictureState = (0, $cozmU.useCallback)(async ()=>{
        await coverPictureState.setHasCoverPicture(true);
    }, [
        coverPictureState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation') && !(0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img')) return;
        // Track status transitions to detect when loading completes
        const prevStatus = prevAIHeaderImageStatusRef.current;
        const wasLoadingWithAcceptance = prevStatus === 'LOADING_WITH_ACCEPTANCE_FLOW';
        prevAIHeaderImageStatusRef.current = aiHeaderImageStatus;
        if (isGeneratingHeaderImage) coverPictureState.setIsUploadingPicture(true);
        else {
            coverPictureState.setIsUploadingPicture(false);
            if (aiHeaderImageFileId && aiHeaderImageStatus !== 'SUCCESSFULLY_SET') {
                // We've just observed `aiHeaderImageFileId` transition from
                // null/undefined to a real media file id, which means the AI
                // generation request has succeeded. Immediately clear the
                // locally-cached previous cover picture id so the old header
                // image stops rendering. Without this, there is a brief flash
                // of the previous image between the loading spinner being
                // removed and the new mediaFileId being committed to the
                // cover picture content property (the property update below
                // is async and only takes effect once the GraphQL
                // subscription fires).
                //
                // Crucially this only runs in the success branch — if
                // generation failed, `aiHeaderImageFileId` stays falsy, this
                // code does not run, and the previous header image remains
                // visible to the user.
                coverPicture.current['draft'] = null;
                // Check if we should show acceptance flow:
                // Either from the stored params (when wrapped function is called) or from status transition
                const lastParams = coverPictureState.state.lastAIGenerationParams;
                const shouldShowAcceptance = lastParams?.showAcceptanceFlow || wasLoadingWithAcceptance;
                const isAIFCAutoGenerated = !shouldShowAcceptance && !!isSmartCreate;
                coverPictureState.setIsCurrentAIFCAutoImage(isAIFCAutoGenerated);
                try {
                    // If showing acceptance flow, don't set status to SUCCESSFULLY_SET yet
                    // User needs to accept first
                    // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
                    handleAIGeneratedUpload(aiHeaderImageFileId, shouldShowAcceptance, isAIFCAutoGenerated);
                } finally{
                    updateCoverPictureState();
                }
                // Show the acceptance flow with repositioning when image is ready
                if (shouldShowAcceptance) {
                    // Clear uploading state to allow acceptance UI to show
                    // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
                    setIsUploadingPicture(false);
                    coverPictureState.setShouldShowAIImageAcceptanceFlow(true);
                    // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
                    setIsRetryingAIImage(false);
                }
            }
        }
    }, [
        isGeneratingHeaderImage,
        coverPictureState,
        aiHeaderImageFileId,
        handleAIGeneratedUpload,
        updateCoverPictureState,
        aiHeaderImageStatus,
        isSmartCreate
    ]);
    // Watch for AI generation error status and show error flag to user
    // Only show flag on TRANSITION into ERROR state, not on re-renders while in ERROR state
    (0, $cozmU.useEffect)(()=>{
        const prevStatus_0 = prevStatusForErrorFlagRef.current;
        const currentStatus = aiHeaderImageStatus;
        // Only show error flag when TRANSITIONING into ERROR state
        // This prevents duplicate flags from re-renders while already in ERROR state
        const isTransitioningToError = prevStatus_0 !== 'ERROR' && currentStatus === 'ERROR';
        // Don't show error flags for AIFC auto-generated images (where the image is
        // generated automatically from the title without user interaction).
        // The auto flow uses 'LOADING' status (no acceptance flow), while user-initiated
        // generation uses 'LOADING_WITH_ACCEPTANCE_FLOW'. We detect auto flow by checking
        // if the previous status was 'LOADING' (not 'LOADING_WITH_ACCEPTANCE_FLOW').
        const wasAIFCAutoGenerated = prevStatus_0 === 'LOADING';
        if (isTransitioningToError && !wasAIFCAutoGenerated) // Due to a false positive
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        showAIGenerationErrorFlag(aiHeaderImageError);
        // Update the ref for next render
        prevStatusForErrorFlagRef.current = currentStatus ?? null;
    }, [
        aiHeaderImageStatus,
        aiHeaderImageError,
        showAIGenerationErrorFlag
    ]);
    // Handler for accepting AI generated image (from AIImageAcceptanceRepositioner)
    const onAcceptAIGeneratedImage = (0, $cozmU.useCallback)(()=>{
        coverPictureState.setShouldShowAIImageAcceptanceFlow(false);
        setAIHeaderImageStatus?.('SUCCESSFULLY_SET');
        coverPictureState.setLastAIGenerationParams(null);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'accepted',
                actionSubject: 'aiGeneratedImage',
                actionSubjectId: 'aiGeneratedHeaderImage',
                source: analyticsSource,
                attributes: {
                    regenerationCount: regenerationCount
                }
            }
        }).fire();
    }, [
        setAIHeaderImageStatus,
        regenerationCount,
        createAnalyticsEvent,
        coverPictureState,
        analyticsSource
    ]);
    // Handler for retrying AI image generation (from AIImageAcceptanceRepositioner)
    const onRetryAIGeneratedImage = (0, $cozmU.useCallback)(async ()=>{
        const lastParams_0 = coverPictureState.state.lastAIGenerationParams;
        if (!generateAIHeaderImage) {
            // eslint-disable-next-line no-console
            console.warn('[AI Header Image] generateAIHeaderImage is not available');
            return;
        }
        if (!lastParams_0) {
            // This should never happen - if the user clicked retry, there should be stored params
            // eslint-disable-next-line no-console
            console.error('[AI Header Image] Cannot retry: no stored generation parameters found');
            return;
        }
        setIsRetryingAIImage(true);
        setRegenerationCount((prev)=>prev + 1);
        await generateAIHeaderImage({
            ...lastParams_0,
            showAcceptanceFlow: true
        });
    }, [
        generateAIHeaderImage,
        coverPictureState.state.lastAIGenerationParams
    ]);
    // Wrapped generateAIHeaderImage that stores params for retry functionality
    const wrappedGenerateAIHeaderImage = (0, $cozmU.useCallback)(async (props)=>{
        if (generateAIHeaderImage) {
            // Store params in container state so we can retry with the same params
            // Using container state ensures params survive component re-mounts
            coverPictureState.setLastAIGenerationParams(props);
            return generateAIHeaderImage(props);
        }
        return undefined;
    }, [
        generateAIHeaderImage,
        coverPictureState
    ]);
    const onRemoveImage = (0, $cozmU.useCallback)(async ()=>{
        coverPictureState.setIsRemovingPicture(true);
        coverPictureState.setIsAddHeaderImageButtonFocused(false);
        const updatePromise_2 = updateContentProperty({
            propertyKey: propertyKeyForMutations,
            isDelete: true,
            hasExistingProperty: hasCoverPicture
        });
        if (isSmartSpaceOverview && updatePromise_2) updatePromise_2.then(async ()=>{
            if (typeof refetch === 'function') await refetch();
            coverPicture.current['draft'] = null;
            setOptimisticMediaCoverPictureId(null);
            coverPictureState.setHasCoverPicture(false);
            coverPictureState.setCoverPictureId(null);
            coverPictureState.setIsModalOpen(false);
            forceUpdate(Math.random());
        });
        else if (updatePromise_2 && isGCP) updatePromise_2.then(async ()=>{
            try {
                if (typeof refetch === 'function') await refetch();
                coverPicture.current['draft'] = null;
                setOptimisticMediaCoverPictureId(null);
                coverPictureState.setHasCoverPicture(false);
                coverPictureState.setCoverPictureId(null);
                coverPictureState.setIsModalOpen(false);
                coverPictureState.setIsAddHeaderImageButtonFocused(false);
                forceUpdate(Math.random());
            } catch (error_6) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error_6, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                });
                (0, $7Sm4c.markErrorAsHandled)(error_6);
            }
        });
        coverPictureState.setIsChangingPicture(false);
        coverPictureState.setIsModalOpen(false);
        // Clear AI image acceptance flow state when image is removed/discarded
        if (coverPictureState.state.shouldShowAIImageAcceptanceFlow) {
            coverPictureState.setShouldShowAIImageAcceptanceFlow(false);
            coverPictureState.setLastAIGenerationParams(null);
            // Set to SUCCESSFULLY_SET
            setAIHeaderImageStatus?.('SUCCESSFULLY_SET');
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'discarded',
                    actionSubject: 'aiGeneratedImage',
                    actionSubjectId: 'aiGeneratedHeaderImage',
                    source: analyticsSource,
                    attributes: {
                        regenerationCount: regenerationCount
                    }
                }
            }).fire();
        }
        coverPictureState.setIsCurrentAIFCAutoImage(false);
        coverPictureState.setIsRemovingPicture(false);
        experienceTracker.succeed({
            name: (0, $irVI7.COVER_PICTURE_REMOVE_EXPERIENCE)
        });
    }, [
        coverPictureState,
        experienceTracker,
        createAnalyticsEvent,
        regenerationCount,
        updateContentProperty,
        hasCoverPicture,
        setAIHeaderImageStatus,
        propertyKeyForMutations,
        isSmartSpaceOverview,
        refetch,
        analyticsSource,
        isGCP
    ]);
    const onImageWidthChange = (0, $cozmU.useCallback)(async (coverPictureWidth)=>{
        if (coverPictureWidth !== coverPictureState.state.coverPictureWidth) {
            coverPictureState.toggleCoverPictureWidthButton(coverPictureWidth);
            //hack the input and outout have different capitalizations TT_TT
            // the mutation returns lowercase, the mutation expects uppercase
            await mutateCoverPictureWidth({
                variables: {
                    contentId: contentId,
                    // Casting to GraphQLCoverPictureWidth as structurally equivalent enums are not equal in TS
                    coverPictureWidth: coverPictureWidth.toUpperCase()
                }
            });
        }
    }, [
        contentId,
        mutateCoverPictureWidth,
        coverPictureState
    ]);
    const onSaveReposition = async (position)=>{
        const currentCoverPictureId = coverPicture.current?.draft?.value.id || (isGCP ? optimisticMediaCoverPictureId || coverPictureState.state.coverPictureId || undefined : undefined);
        const currentCoverPicturePosition = coverPicture.current?.draft?.value.position ?? (0, $75Ax4.DEFAULT_POSITION_VALUE);
        if (!currentCoverPictureId) return;
        // check that the position isn't the same as the current one
        if (position != currentCoverPicturePosition) {
            const version_0 = String((coverPicture.current?.draft?.version || 0) + 1);
            const propertyValue_2 = JSON.stringify({
                id: currentCoverPictureId,
                position: position
            });
            coverPicture.current['draft'] = {
                value: {
                    id: currentCoverPictureId,
                    position: position
                },
                version: parseInt(version_0)
            };
            const updatePromise_3 = updateContentProperty({
                propertyKey: propertyKeyForMutations,
                propertyValue: propertyValue_2,
                isDelete: false,
                hasExistingProperty: hasCoverPicture
            });
            if (isSmartSpaceOverview && updatePromise_3) updatePromise_3.then(()=>{
                refetchAfterMutation();
            });
        }
    };
    const openMediaBrowser = ()=>{
        setIsMediaBrowserOpen(true);
    };
    const closeMediaBrowser = ()=>{
        setIsMediaBrowserOpen(false);
    };
    const createLiveDocHeaderImageAnalyticsEvent = (0, $cozmU.useCallback)((isUnsplashImage)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'LiveDocHeaderImage',
                actionSubjectId: 'liveDocHeaderImage',
                source: 'liveDocHeaderImage',
                attributes: {
                    headerImageType: isUnsplashImage ? 'unsplash' : 'user-uploaded',
                    isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_ai_header_image_generation'),
                    isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img')
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasCoverPicture && isLivePage && isAllowedExternalCoverPicture != null) createLiveDocHeaderImageAnalyticsEvent(isAllowedExternalCoverPicture);
    }, [
        isAllowedExternalCoverPicture,
        isLivePage,
        hasCoverPicture,
        createLiveDocHeaderImageAnalyticsEvent
    ]);
    const effectiveCoverPictureId = coverPicture.current.draft?.value.id || (coverPictureState.state.coverPictureId && isGCP ? coverPictureState.state.coverPictureId : undefined);
    const effectiveCoverPicturePosition = coverPicture.current.draft?.value.position ?? (0, $75Ax4.DEFAULT_POSITION_VALUE);
    const optimisticCoverPictureIdForRender = optimisticMediaCoverPictureId || coverPictureState.state.coverPictureId;
    const effectiveIsAllowedExternalCoverPicture = effectiveCoverPictureId && isGCP ? (0, $3WPGR.isAllowedExternalCoverPictureUrl)(effectiveCoverPictureId) : isAllowedExternalCoverPicture;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "editor-page-cover-picture",
        // cc_editor_two_stage_hydration_removal - When cleaning up this experiment, also remove the related TwoStageHydration component
        enabled: !(0, $6mKj3.expValEquals)('cc_editor_two_stage_hydration_removal', 'editorCoverPicture', true),
        ssrPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, hasCoverPicture && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
									@container editor-area (width < 760px) {
										.cover-picture-wrapper-dangerously-set-inner-html {
											height: ${smartSpaceOverviewHeight ?? 147}px
										}
									}
									@container editor-area (width >= 4071px) {
										.cover-picture-wrapper-dangerously-set-inner-html {
											height: ${smartSpaceOverviewHeight ?? 750}px
										}
									}
									`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d3478acd5148f8b$export$7291ee1cb3635b5b), {
        hasCoverPicture: hasCoverPicture,
        isUploadingPicture: isUploadingPicture,
        "data-testid": "cover-picture-wrapper",
        width: width,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cover-picture-wrapper-dangerously-set-inner-html",
        isFixedWidthImageOption: isFixedWidthImageOption,
        smartSpaceOverviewHeight: smartSpaceOverviewHeight,
        isSmartSpaceOverview: isSmartSpaceOverview,
        isReadOnly: isReadOnly
    }, hasCoverPicture && (mediaConfig || hasSSRConfigInSSRModeOrHydration) && (effectiveIsAllowedExternalCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4dbf19c0ece58c9f$export$8e0ec3f3e7cffe52), {
        coverPicture: coverPicture,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        isFixedWidthImageOption: isFixedWidthImageOption,
        smartSpaceOverviewHeight: smartSpaceOverviewHeight,
        coverPictureDataPosition: effectiveCoverPicturePosition,
        coverPictureDataId: effectiveCoverPictureId || coverPictureDataId,
        isRoundedCorners: isSmartSpaceOverview
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6daaa50e0e3ea99a$export$22e679d20747684f), {
        coverPicture: coverPicture,
        mediaConfig: mediaConfig,
        ssrConfig: ssrConfig,
        contentId: contentId,
        coverPictureId: effectiveCoverPictureId,
        coverPicturePosition: effectiveCoverPicturePosition,
        showErrorFlag: showErrorFlag,
        hasSSRConfigInSSRModeOrHydration: hasSSRConfigInSSRModeOrHydration,
        useEditorMediaConfig: optimisticCoverPictureIdForRender === effectiveCoverPictureId && isGCP,
        isFixedWidthImageOption: isFixedWidthImageOption,
        smartSpaceOverviewHeight: smartSpaceOverviewHeight,
        isAIGenerated: !!aiHeaderImageFileId,
        isRoundedCorners: isSmartSpaceOverview
    })), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $689140bd887be349$export$4103f8c62b69a0b3), {
        hasCoverPicture: hasCoverPicture,
        openMediaBrowser: openMediaBrowser,
        onRemoveImage: onRemoveImage,
        userOffline: userOffline,
        isUploadingPicture: isUploadingPicture,
        handleUnsplashUpload: handleUnsplashUpload,
        setIsUploadingPicture: setIsUploadingPicture,
        initialPicturePosition: effectiveCoverPicturePosition,
        onSaveReposition: onSaveReposition,
        shouldShowReposition: shouldShowReposition,
        setShouldShowReposition: setShouldShowReposition,
        coverPictureState: coverPictureState,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        forceUpdate: forceUpdate,
        contentId: contentId,
        dynamicCoverImageHeight: dynamicCoverImageHeight,
        smartSpaceOverviewHeight: smartSpaceOverviewHeight,
        onImageWidthChange: isSmartSpaceOverview ? undefined : onImageWidthChange,
        isRoundedCorners: isSmartSpaceOverview,
        spaceKey: spaceKey,
        isFixedWidthImageOption: isFixedWidthImageOption,
        generateAIHeaderImage: generateAIHeaderImage ? wrappedGenerateAIHeaderImage : undefined,
        // AI Image Acceptance Flow props
        shouldShowAIImageAcceptanceFlow: coverPictureState.state.shouldShowAIImageAcceptanceFlow,
        onAcceptAIGeneratedImage: onAcceptAIGeneratedImage,
        onRetryAIGeneratedImage: onRetryAIGeneratedImage,
        isRetryingAIImage: isRetryingAIImage,
        analyticsSource: analyticsSource
    })), !isReadOnly && mediaConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZJRm.BrowserLoader), {
        mediaClientConfig: {
            authProvider: mediaConfig?.authProvider,
            useSha256ForUploads: mediaConfig?.useSha256ForUploads
        },
        config: {
            multiple: false,
            fileExtensions: [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif'
            ],
            uploadParams: {
                collection: mediaConfig.collection,
                onUploadRejection: mediaConfig?.onUploadRejection
            }
        },
        isOpen: isMediaBrowserOpen,
        onClose: closeMediaBrowser,
        onUploadsStart: handleUploadStart,
        onError: showErrorFlag,
        onEnd: handleUploadEnd
    })));
});
const $e4cacfdae9b2fb53$export$61fcba19b6a07b00 = (0, $7aRa9.withFlags)((0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($e4cacfdae9b2fb53$var$EditorPageCoverPictureComponent));
module.exports["EditorPageCoverPicture"] = $e4cacfdae9b2fb53$export$61fcba19b6a07b00;

});

parcelRegister("5ZJRm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");



class $928d71b7a1b056f3$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            Promise.resolve((parcelRequire("g0fSg"))),
            (parcelRequire("aZiBV"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
        };
    }
}
$928d71b7a1b056f3$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $928d71b7a1b056f3$export$3ce634ac4a869e2c;

});

parcelRegister("aZiBV", function(module, exports) {

let $7ffe099183cdb312$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ffe099183cdb312$var$load("coGVA"),
    $7ffe099183cdb312$var$load("ikM8d"),
    $7ffe099183cdb312$var$load("10DpY"),
    $7ffe099183cdb312$var$load("20wSi"),
    $7ffe099183cdb312$var$load("5ouIR")
]).then(()=>parcelRequire('e7T2P'));

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("2vVvv", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $57725dc45b51a081$var$attachmentSizeErrorFlagI18n = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "fabric-media-support.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    }
});
const $57725dc45b51a081$var$sizeLimitLearnMoreLink = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
const $57725dc45b51a081$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    const k = 1024;
    const decimals = 2;
    const units = [
        'bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    let maxIndex = units.length - 1;
    let exponent = Math.floor(Math.log(bytes) / Math.log(k));
    if (maxMagnitude && maxMagnitude < maxIndex) maxIndex = maxMagnitude;
    exponent = exponent > maxIndex ? maxIndex : exponent;
    return `${parseFloat((bytes / Math.pow(k, exponent)).toFixed(decimals))} ${units[exponent]}`;
};
const $57725dc45b51a081$export$1c61cf0ed486df46 = (data, intl)=>{
    if (data.reason === 'fileSizeLimitExceeded') return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorDescription, {
            size: $57725dc45b51a081$export$f2d538a5633fea72(data.limit)
        }),
        actions: [
            {
                content: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.learnMore),
                onClick: ()=>{
                    window.open($57725dc45b51a081$var$sizeLimitLearnMoreLink, '_blank');
                }
            }
        ]
    };
    else return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorDescription)
    };
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $57725dc45b51a081$export$1c61cf0ed486df46;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("dA1Sn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = fullCycleOutput === undefined;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $cozmU.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $cozmU.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if (!enabled) return children;
    if (hydrated) {
        let t3;
        if ($[0] !== name || $[1] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[0] = name;
            $[1] = ssrPlaceholder;
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== children || $[5] !== name || $[6] !== t3) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                style: t4
            }, children);
            $[4] = children;
            $[5] = name;
            $[6] = t3;
            $[7] = t5;
        } else t5 = $[7];
        return t5;
    }
    const innerHTML = fullCycleOutput;
    let t3;
    if ($[8] !== name || $[9] !== ssrPlaceholder) {
        t3 = ssrPlaceholder ? {
            "data-ssr-placeholder": name,
            "data-ssr-placeholder-replace": name
        } : {};
        $[8] = name;
        $[9] = ssrPlaceholder;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== innerHTML) {
        t4 = {
            __html: innerHTML
        };
        $[11] = innerHTML;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            position: "relative",
            height: "100%",
            width: "100%"
        };
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            ...t3,
            dangerouslySetInnerHTML: t4,
            style: t5
        });
        $[14] = name;
        $[15] = t3;
        $[16] = t4;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("3gyyc", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

const $59e4a4ba3e3599a7$export$7e063004a2621936 = ()=>{
    try {
        const isSSRRendered = // In most places there is no document when running on server-side
        typeof document === 'undefined' || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        typeof $1P2f3 !== 'undefined' && $1P2f3.env?.REACT_SSR || typeof window !== 'undefined' && window.__SSR_RENDERED__ || globalThis.__SSR_RENDERED__;
        const isSSRReactStreaming = typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__ || globalThis.__SSR_REACT_STREAMING__;
        return Boolean(isSSRRendered) && Boolean(isSSRReactStreaming);
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};
module.exports["isSSRStreaming"] = $59e4a4ba3e3599a7$export$7e063004a2621936;

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $eB536 = parcelRequire("eB536");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$e114ec4e88c7fe33 = (0, $eB536.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId,
        __callerPackage__: "content-topper"
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["useTitleContentPropertiesForPublishedPage_content"] = $20e32f1deb8c1fe0$export$e114ec4e88c7fe33;
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("eB536", function(module, exports) {
/**
 * @generated SignedSource<<f3aa298d710112bdac45cdae3936c970>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3cc0a8cff50ad3c7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useTitleContentPropertiesForPublishedPage_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            },
            {
                "alias": "pageTitleDraft",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-draft"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-draft\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3cc0a8cff50ad3c7$var$node.hash = "6913c519b951b36b57b6c77657b055fd";
var $3cc0a8cff50ad3c7$export$2e2bcd8739ae039 = $3cc0a8cff50ad3c7$var$node;
module.exports["default"] = $3cc0a8cff50ad3c7$export$2e2bcd8739ae039;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
const $4cdfc0aeee394c11$export$a682f4bbb3650e11 = 200;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;
module.exports["SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH"] = $4cdfc0aeee394c11$export$a682f4bbb3650e11;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<809e2044c3792f08e4a1f1fd3c386e1c>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("bCpIa", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9R1n8 = parcelRequire("9R1n8");


var $hX2PJ = parcelRequire("hX2PJ");

// Copy of CoverPictureQuery_content for EditorContentUnifiedQuery: View Page spreads the shared
// fragment @relay(mask: false), which rules out @catch on it. Kept equal by a parity test.
const $4217a03c3c7de871$var$coverPictureFragmentNode = (0, $9R1n8.default);
function $4217a03c3c7de871$export$6571e7eeada9bf54(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId,
            mapData: $4217a03c3c7de871$var$_temp
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    return (0, $hX2PJ.useEditorContentFragment)("coverPictureFragment", $4217a03c3c7de871$var$coverPictureFragmentNode, t1);
}
function $4217a03c3c7de871$var$_temp(value) {
    return {
        content: {
            nodes: [
                {
                    id: value.id,
                    properties: value.coverPictureProperties
                }
            ]
        }
    };
}
module.exports["useCoverPictureFragment"] = $4217a03c3c7de871$export$6571e7eeada9bf54;

});

parcelRegister("9R1n8", function(module, exports) {
/**
 * @generated SignedSource<<5049c53c475bf710d8eb4ef97c67533e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3f33cda2acd9283$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "catchTo": "RESULT"
        },
        "name": "useCoverPictureFragment_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "coverPictureProperties",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "cover-picture-id-draft",
                            "cover-picture-id-published"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
            }
        ],
        "type": "Content"
    };
}();
$f3f33cda2acd9283$var$node.hash = "42bffc5c08dfd5efc775bba301ca4d1b";
var $f3f33cda2acd9283$export$2e2bcd8739ae039 = $f3f33cda2acd9283$var$node;
module.exports["default"] = $f3f33cda2acd9283$export$2e2bcd8739ae039;

});

parcelRegister("hX2PJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $26Yfd = parcelRequire("26Yfd");


var $8bGvp = parcelRequire("8bGvp");

function $4a4d540a0776d558$var$identity(value) {
    return value;
}
function $4a4d540a0776d558$export$b9f4f60a9d12fe91(key, fragmentNode, t0) {
    const $ = (0, $bDgLe.c)(11);
    const { contentId: contentId, skip: t1, mapData: mapData } = t0;
    const skip = t1 === undefined ? false : t1;
    const fragment = (0, $8bGvp.useEditorContentFragments)()[key];
    const isProvided = fragment.isProvided && fragment.contentId === contentId;
    const result = (0, $6SsN4.useFragment)(fragmentNode, isProvided && !skip ? fragment.ref : null);
    const isLoading = isProvided && !skip && fragment.isLoading;
    const stableMapData = (0, $26Yfd.useStableCallback)(mapData ?? $4a4d540a0776d558$var$identity);
    let t2;
    if ($[0] !== result || $[1] !== stableMapData) {
        t2 = result?.ok ? stableMapData(result.value) : undefined;
        $[0] = result;
        $[1] = stableMapData;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== fragmentNode || $[4] !== result) {
        t3 = result?.ok === false ? new Error(`${(0, $eqEJl.getFragment)(fragmentNode).name} field error`, {
            cause: result.errors
        }) : undefined;
        $[3] = fragmentNode;
        $[4] = result;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== isLoading || $[7] !== isProvided || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            isProvided: isProvided,
            isLoading: isLoading,
            data: t2,
            error: t3
        };
        $[6] = isLoading;
        $[7] = isProvided;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
}
module.exports["useEditorContentFragment"] = $4a4d540a0776d558$export$b9f4f60a9d12fe91;

});

parcelRegister("8bGvp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $69682d2fbc90456d$var$getNode = (data)=>data.content?.nodes?.[0];
// Where each fragment's ref is in the operation's data; adding a fragment to the query without a
// selector here fails to compile.
const $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS = {
    contentTypesHeaderFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentTypesHeaderFragment,
    emojiTitleFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.emojiTitleFragment,
    emojiEverSetPropertyFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.emojiEverSetPropertyFragment,
    contentAppearanceFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentAppearanceFragment,
    coverPictureFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.coverPictureFragment,
    titleContentPropertiesFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.titleContentPropertiesFragment,
    contentModeFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentModeFragment,
    shareAndRestrictButtonFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.shareAndRestrictButtonFragment,
    shareAndRestrictButtonPublicLinkFragment: (data)=>data.shareAndRestrictButtonPublicLinkFragment
};
const $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_KEYS = Object.keys($69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS);
function $69682d2fbc90456d$var$mapFragments(toFragment) {
    return Object.fromEntries($69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_KEYS.map((key)=>[
            key,
            toFragment(key)
        ]));
}
function $69682d2fbc90456d$export$56cbeadb27426f30(data, { contentId: contentId, isLoading: isLoading }) {
    return $69682d2fbc90456d$var$mapFragments((key)=>({
            isProvided: true,
            ref: $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS[key](data) ?? null,
            contentId: contentId,
            isLoading: isLoading
        }));
}
const $69682d2fbc90456d$var$NOT_PROVIDED_FRAGMENTS = $69682d2fbc90456d$var$mapFragments(()=>({
        isProvided: false
    }));
const $69682d2fbc90456d$export$faab0246835c7509 = (0, $cozmU.createContext)($69682d2fbc90456d$var$NOT_PROVIDED_FRAGMENTS);
function $69682d2fbc90456d$export$2e53e9edef0785f2() {
    return (0, $cozmU.useContext)($69682d2fbc90456d$export$faab0246835c7509);
}
module.exports["createEditorContentFragments"] = $69682d2fbc90456d$export$56cbeadb27426f30;
module.exports["EditorContentFragmentsContext"] = $69682d2fbc90456d$export$faab0246835c7509;
module.exports["useEditorContentFragments"] = $69682d2fbc90456d$export$2e53e9edef0785f2;

});

parcelRegister("gH7sg", function(module, exports) {
const $0aaa27c2ee4953f8$export$12cc65019788286c = {
    photorealistic: 'photorealistic',
    abstract: 'abstract',
    watercolors: 'watercolors',
    graphic_design: 'graphic_design',
    headerImages: 'header_images',
    headerImagesSketch: 'header_images_sketch',
    headerImagesThreeD: 'header_images_3d',
    headerImagesWatercolors: 'header_images_watercolors',
    landscape: 'landscape',
    sketch: 'sketch',
    threeD: '3d'
};
const $0aaa27c2ee4953f8$export$607fdde54add7f63 = {
    auto: 'auto',
    fast: 'fast',
    high: 'high',
    max: 'max'
};
module.exports["IMAGE_GENERATION_THEMES"] = $0aaa27c2ee4953f8$export$12cc65019788286c;
module.exports["IMAGE_GENERATION_MODELS"] = $0aaa27c2ee4953f8$export$607fdde54add7f63;

});

parcelRegister("9XB2W", function(module, exports) {
class $8fc43f5e489bb303$var$EventHub {
    /**
   * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
   *
   * @param {object} params - The subscription parameters.
   * @param {T} params.event - The name of the event to subscribe to.
   * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
   * It receives the event data as its parameter.
   * @returns {object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
   *
   * @example
   * // Subscribing to an event
   * const subscription = eventHub.subscribe({
   *   event: 'start prompt',
   *   callback: (data) => {
   *     console.log('Received start prompt event:', data);
   *   },
   * });
   *
   * // Later, to unsubscribe
   * subscription.unsubscribe();
   */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
   * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event to the editor
   * eventHub.publishToEditor({
   *   event: 'start prompt',
   *   data: {
   *     prompt: 'issue reformatter',
   *     targetEditorId,
   *     analyticSourceId: 'jiraIssueReformatterExternalButton',
   *   },
   * });
   */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
   * Publishes an event originating from the editor, invoking all registered subscribers for that event.
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event from the editor
   * eventHub.publishFromEditor({
   *   event: 'replace title in confluence',
   *   data: {
   *     analyticSourceId: 'confluenceTitleToolbar',
   *     sourceEditorId,
   *     title: textContent,
   *   },
   * });
   */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
}
const $8fc43f5e489bb303$export$e17a52e5da72c4cb = new $8fc43f5e489bb303$var$EventHub();
module.exports["eventHub"] = $8fc43f5e489bb303$export$e17a52e5da72c4cb;

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)();
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $7m1pr = parcelRequire("7m1pr");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $7m1pr.RelayError)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");


var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = appearance === "default" && $7e44050607850249$var$styles.defaultAppearance;
    const t3 = appearance === "subtle" && $7e44050607850249$var$styles.subtleAppearance;
    const t4 = appearance === "inverse" && $7e44050607850249$var$styles.inverseAppearance;
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== target || $[13] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[12] = target;
        $[13] = testId;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== children || $[16] !== htmlAttributes || $[17] !== newWindowLabel || $[18] !== ref || $[19] !== t6 || $[20] !== t7 || $[21] !== target || $[22] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[15] = children;
        $[16] = htmlAttributes;
        $[17] = newWindowLabel;
        $[18] = ref;
        $[19] = t6;
        $[20] = t7;
        $[21] = target;
        $[22] = testId;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && $7e44050607850249$var$styles.defaultAppearance, appearance === 'subtle' && $7e44050607850249$var$styles.subtleAppearance, appearance === 'inverse' && $7e44050607850249$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("5BvyC", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/blogpost/manifest.ts
var $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $4148e3160e6a23b4$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $4148e3160e6a23b4$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("8jDil", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/page/manifest.ts
var $60de943ef043ed79$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $60de943ef043ed79$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $60de943ef043ed79$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("aR3ec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("e3Wrf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$inputMotionStyles = {
    legacy: "_23rrnH5Vpu",
    base: "_23rrnHGIwA"
};
const $f7ddda300dd34381$var$finessePlaceholderStyles = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
    subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textarea uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_2sNsIgmnOE _1gitD220Hp",
    monospace: "_2sNsIgmnOE _0WKd3Gfx9v _1gitD220Hp _3n0EfXdh5F"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_2HIj7GD4qA",
    vertical: "_2HIj7GbI28",
    auto: "_2HIj7GZSoF",
    smart: "_2HIj7GYbGa",
    none: "_2HIj7GYbGa"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(59);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const isInputMotionEnabled = (0, $iDrrr.fg)("platform-dst-motion-uplift-input");
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    const t20 = (0, $hekY6.default)([
        "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
        !isInputMotionEnabled && $f7ddda300dd34381$var$inputMotionStyles.legacy,
        isInputMotionEnabled && isInteractive && $f7ddda300dd34381$var$inputMotionStyles.base,
        (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_3AxjleZpcK",
        $f7ddda300dd34381$var$appearanceStyles[appearance],
        $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
        $f7ddda300dd34381$var$resizeStyles[resize],
        "_22P5CgPgdP _2Ombu6q5bj"
    ]);
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[36] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[36] = t21;
        $[37] = t22;
    } else t22 = $[37];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[38] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[38] = t23;
        $[39] = t24;
    } else t24 = $[39];
    let t25;
    if ($[40] !== maxHeight || $[41] !== style || $[42] !== t22 || $[43] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[40] = maxHeight;
        $[41] = style;
        $[42] = t22;
        $[43] = t24;
        $[44] = t25;
    } else t25 = $[44];
    let t26;
    if ($[45] !== controlProps || $[46] !== getTextAreaRef || $[47] !== handleOnChange || $[48] !== isDisabled || $[49] !== isReadOnly || $[50] !== isRequired || $[51] !== minimumRows || $[52] !== onBlurWithAnalytics || $[53] !== onFocusWithAnalytics || $[54] !== rest || $[55] !== t20 || $[56] !== t25 || $[57] !== value) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[45] = controlProps;
        $[46] = getTextAreaRef;
        $[47] = handleOnChange;
        $[48] = isDisabled;
        $[49] = isReadOnly;
        $[50] = isRequired;
        $[51] = minimumRows;
        $[52] = onBlurWithAnalytics;
        $[53] = onFocusWithAnalytics;
        $[54] = rest;
        $[55] = t20;
        $[56] = t25;
        $[57] = value;
        $[58] = t26;
    } else t26 = $[58];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const isInputMotionEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            !isInputMotionEnabled && $f7ddda300dd34381$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $f7ddda300dd34381$var$inputMotionStyles.base,
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("4fGOw", function(module, exports) {

var $jx5V5 = parcelRequire("jx5V5");


var $lNvN4 = parcelRequire("lNvN4");

const $dc2272ad9447ddc9$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $jx5V5.useStore)(store, selector, equals);
function $dc2272ad9447ddc9$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $dc2272ad9447ddc9$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $dc2272ad9447ddc9$export$8a9cc8c330400af8;

});

parcelRegister("jx5V5", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $e385b0e7bfdc7f87$export$6ccbb43953eebf8);

var $3xeSM = parcelRequire("3xeSM");


var $cozmU = parcelRequire("cozmU");


var $aSzLn = parcelRequire("aSzLn");

var $e385b0e7bfdc7f87$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $e385b0e7bfdc7f87$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
const { useSyncExternalStoreWithSelector: $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($aSzLn)));
let $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = false;
const $e385b0e7bfdc7f87$var$identity = (arg)=>arg;
function $e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector = $e385b0e7bfdc7f87$var$identity, equalityFn) {
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$e385b0e7bfdc7f87$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = true;
    }
    const slice = $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $e385b0e7bfdc7f87$var$useDebugValue(slice);
    return slice;
}
const $e385b0e7bfdc7f87$var$createImpl = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $3xeSM.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $e385b0e7bfdc7f87$export$185802fd694ee1f5 = (createState)=>createState ? $e385b0e7bfdc7f87$var$createImpl(createState) : $e385b0e7bfdc7f87$var$createImpl;
var $e385b0e7bfdc7f87$export$2e2bcd8739ae039 = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $e385b0e7bfdc7f87$export$185802fd694ee1f5(createState);
};

});

parcelRegister("cvZVo", function(module, exports) {
const $b878f2b45b924d24$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
module.exports["isImageRepresentationReady"] = $b878f2b45b924d24$export$4e33ccde53b4f0bf;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});


//# sourceMappingURL=EditorPageCoverPicture.734abae6.js.map
